webpackJsonpHairCare(["site__evo"],{

/***/ "D:\\a\\1\\s\\client\\src\\site__evo\\sprites nonrecursive /\\.svg$/":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./360-image-icon-large.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\360-image-icon-large.svg",
	"./MSDS.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\MSDS.svg",
	"./PDF-big.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\PDF-big.svg",
	"./account-created.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-created.svg",
	"./account-dashboard.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-dashboard.svg",
	"./account-statement-medium.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-statement-medium.svg",
	"./account-statement-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-statement-small.svg",
	"./account-statements.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-statements.svg",
	"./add-card.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\add-card.svg",
	"./added-to-cart.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\added-to-cart.svg",
	"./address.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\address.svg",
	"./afterpay-available-bw.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\afterpay-available-bw.svg",
	"./afterpay-available.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\afterpay-available.svg",
	"./alert-notification-on-homepage.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\alert-notification-on-homepage.svg",
	"./alert-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\alert-small.svg",
	"./alert.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\alert.svg",
	"./arrow-up.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\arrow-up.svg",
	"./back-in-stock-alerts.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\back-in-stock-alerts.svg",
	"./bag.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\bag.svg",
	"./become-a-stockist-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\become-a-stockist-small.svg",
	"./become-a-stockist.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\become-a-stockist.svg",
	"./box.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\box.svg",
	"./boxes.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\boxes.svg",
	"./business-profile.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\business-profile.svg",
	"./business.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\business.svg",
	"./calendar.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\calendar.svg",
	"./cancelled.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\cancelled.svg",
	"./card-add-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-add-small.svg",
	"./card-add.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-add.svg",
	"./card-default-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-default-small.svg",
	"./card-default.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-default.svg",
	"./card-remove-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-remove-small.svg",
	"./card-remove.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-remove.svg",
	"./card.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card.svg",
	"./cart-empty.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\cart-empty.svg",
	"./cart.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\cart.svg",
	"./chart.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\chart.svg",
	"./clock.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\clock.svg",
	"./close-tiny.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\close-tiny.svg",
	"./close-xsmall.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\close-xsmall.svg",
	"./close.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\close.svg",
	"./collapse-large.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\collapse-large.svg",
	"./collapse.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\collapse.svg",
	"./communication-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\communication-small.svg",
	"./communication.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\communication.svg",
	"./confirmed.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\confirmed.svg",
	"./contacts-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\contacts-small.svg",
	"./contacts.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\contacts.svg",
	"./currency-au.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\currency-au.svg",
	"./currency.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\currency.svg",
	"./dashboard-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dashboard-small.svg",
	"./dashboard.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dashboard.svg",
	"./date.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\date.svg",
	"./deal-book.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\deal-book.svg",
	"./diamond.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\diamond.svg",
	"./document.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\document.svg",
	"./dropdown-indicator-down.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dropdown-indicator-down.svg",
	"./dropdown-indicator-up.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dropdown-indicator-up.svg",
	"./email-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\email-social.svg",
	"./email.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\email.svg",
	"./error.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\error.svg",
	"./expand-large.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\expand-large.svg",
	"./expand-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\expand-small.svg",
	"./external-site-link.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\external-site-link.svg",
	"./external-site.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\external-site.svg",
	"./facebook-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\facebook-social.svg",
	"./faster-checkout.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\faster-checkout.svg",
	"./file.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\file.svg",
	"./free-shipping-bw.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\free-shipping-bw.svg",
	"./general.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\general.svg",
	"./green-success.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\green-success.svg",
	"./green.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\green.svg",
	"./hamburger-nav.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\hamburger-nav.svg",
	"./handshake.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\handshake.svg",
	"./help-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\help-small.svg",
	"./help.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\help.svg",
	"./history.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\history.svg",
	"./important.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\important.svg",
	"./info-ui.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\info-ui.svg",
	"./info.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\info.svg",
	"./instagram-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\instagram-small.svg",
	"./instagram-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\instagram-social.svg",
	"./instructor.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\instructor.svg",
	"./internet-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\internet-social.svg",
	"./invoice.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\invoice.svg",
	"./large-chevron-down.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\large-chevron-down.svg",
	"./large-chevron-up.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\large-chevron-up.svg",
	"./lightbulb.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\lightbulb.svg",
	"./link-arrow-left.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\link-arrow-left.svg",
	"./link-arrow-right-large.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\link-arrow-right-large.svg",
	"./link-arrow-right.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\link-arrow-right.svg",
	"./linkedin-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\linkedin-social.svg",
	"./location-pin-medium.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location-pin-medium.svg",
	"./location-pin-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location-pin-small.svg",
	"./location-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location-small.svg",
	"./location.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location.svg",
	"./logout.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\logout.svg",
	"./make-default.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\make-default.svg",
	"./manage-addresses.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\manage-addresses.svg",
	"./my-account-sign-in.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\my-account-sign-in.svg",
	"./my-orders.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\my-orders.svg",
	"./new-window.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\new-window.svg",
	"./newsletters.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\newsletters.svg",
	"./no-orders-in-this-account.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\no-orders-in-this-account.svg",
	"./notification-clock.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-clock.svg",
	"./notification-error.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-error.svg",
	"./notification-important.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-important.svg",
	"./notification-info.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-info.svg",
	"./notification-outofstock.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-outofstock.svg",
	"./notification-stop.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-stop.svg",
	"./notification-success.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-success.svg",
	"./notification.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification.svg",
	"./notify-me-pop-up.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notify-me-pop-up.svg",
	"./orange-high-importance.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orange-high-importance.svg",
	"./order-alt.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-alt.svg",
	"./order-status-cancelled.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-status-cancelled.svg",
	"./order-status-confirmed.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-status-confirmed.svg",
	"./order-status-shipped.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-status-shipped.svg",
	"./order-summary.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-summary.svg",
	"./orders-empty.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orders-empty.svg",
	"./orders-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orders-small.svg",
	"./orders.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orders.svg",
	"./out-of-stock-nothing-in-cart.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\out-of-stock-nothing-in-cart.svg",
	"./page.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\page.svg",
	"./pagination-first-arrow.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-first-arrow.svg",
	"./pagination-last-arrow.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-last-arrow.svg",
	"./pagination-next-arrow.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-next-arrow.svg",
	"./pagination-prev-arrow.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-prev-arrow.svg",
	"./payment-method.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\payment-method.svg",
	"./payment-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\payment-small.svg",
	"./payments.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\payments.svg",
	"./pdf-attachment.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pdf-attachment.svg",
	"./pdf.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pdf.svg",
	"./person.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\person.svg",
	"./personal-details-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\personal-details-small.svg",
	"./personal-details.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\personal-details.svg",
	"./peta-accredited-bw.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\peta-accredited-bw.svg",
	"./phone.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\phone.svg",
	"./pin.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pin.svg",
	"./placeholder.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\placeholder.svg",
	"./play-button.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\play-button.svg",
	"./price-tag-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\price-tag-small.svg",
	"./price-tag.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\price-tag.svg",
	"./print.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\print.svg",
	"./professional-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\professional-small.svg",
	"./promotions-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\promotions-small.svg",
	"./promotions.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\promotions.svg",
	"./purple-standard.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\purple-standard.svg",
	"./red-error.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\red-error.svg",
	"./redo.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\redo.svg",
	"./refund.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\refund.svg",
	"./remove-cart-delete.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\remove-cart-delete.svg",
	"./remove.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\remove.svg",
	"./reorder-all.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\reorder-all.svg",
	"./returns-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\returns-small.svg",
	"./returns.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\returns.svg",
	"./salon-support.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\salon-support.svg",
	"./search-about-us.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-about-us.svg",
	"./search-brochures.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-brochures.svg",
	"./search-colour-chart.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-colour-chart.svg",
	"./search-education.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-education.svg",
	"./search-error.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-error.svg",
	"./search-guides.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-guides.svg",
	"./search-help-center.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-help-center.svg",
	"./search-loading.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-loading.svg",
	"./search-manuals.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-manuals.svg",
	"./search-noresult.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-noresult.svg",
	"./search-services.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-services.svg",
	"./search.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search.svg",
	"./shipped.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\shipped.svg",
	"./shipping.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\shipping.svg",
	"./slider-arrow-left.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\slider-arrow-left.svg",
	"./slider-arrow-right.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\slider-arrow-right.svg",
	"./small-chevron-down.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\small-chevron-down.svg",
	"./small-chevron-right.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\small-chevron-right.svg",
	"./small-chevron-up.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\small-chevron-up.svg",
	"./speech-bubble.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\speech-bubble.svg",
	"./stockist-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stockist-small.svg",
	"./stockist.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stockist.svg",
	"./stop.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stop.svg",
	"./stores-stockists.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stores-stockists.svg",
	"./subnav-toggle--indicator-closed.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\subnav-toggle--indicator-closed.svg",
	"./subnav-toggle--indicator-opened.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\subnav-toggle--indicator-opened.svg",
	"./success-tick-for-all-success.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\success-tick-for-all-success.svg",
	"./success.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\success.svg",
	"./support.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\support.svg",
	"./telephone-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\telephone-small.svg",
	"./telephone.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\telephone.svg",
	"./text-link-arrow-back.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\text-link-arrow-back.svg",
	"./text-link-arrow-forward.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\text-link-arrow-forward.svg",
	"./text-link-arrow.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\text-link-arrow.svg",
	"./tick-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\tick-small.svg",
	"./tick.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\tick.svg",
	"./tiktok-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\tiktok-social.svg",
	"./trash-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\trash-small.svg",
	"./trash.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\trash.svg",
	"./twitter-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\twitter-social.svg",
	"./ui-tick.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\ui-tick.svg",
	"./user.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\user.svg",
	"./usp-diamond.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-diamond.svg",
	"./usp-education.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-education.svg",
	"./usp-free-delivery.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-free-delivery.svg",
	"./usp-truck.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-truck.svg",
	"./view-password-off.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\view-password-off.svg",
	"./view-password-on.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\view-password-on.svg",
	"./view-previous-orders.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\view-previous-orders.svg",
	"./website-small.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\website-small.svg",
	"./website.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\website.svg",
	"./your-cart-is-empty.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\your-cart-is-empty.svg",
	"./your-order-confirmed.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\your-order-confirmed.svg",
	"./youtube-social.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\youtube-social.svg",
	"./zoom-in.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\zoom-in.svg",
	"./zoom-out.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\zoom-out.svg",
	"./zoom.svg": "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\zoom.svg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "D:\\a\\1\\s\\client\\src\\site__evo\\sprites nonrecursive /\\.svg$/";

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\components\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\components\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\utilities\\index.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\file-loader\\dist\\cjs.js??ref--5-0!D:\\a\\1\\s\\node_modules\\extract-loader\\lib\\extractLoader.js!D:\\a\\1\\s\\node_modules\\html-loader\\index.js??ref--5-2!D:\\a\\1\\s\\client\\src\\site__evo\\favicons\\html_code.html"); /* Favicons entry point for webpack
                                       * html_code.html as expected output from realfavicongenerator.net
                                       * manually insert `WEBPACKHACK` to content attribute of meta[name="msapplication-config"] i.e.
                                       * <meta name="msapplication-config" WEBPACKHACKcontent="./browserconfig.xml">
                                       */

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
SVG Sprite
*/
var files = __webpack_require__("D:\\a\\1\\s\\client\\src\\site__evo\\sprites nonrecursive /\\.svg$/");
files.keys().forEach(files);

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\utilities\\ally.js.bundle.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _key = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\when\\key.js");

var _key2 = _interopRequireDefault(_key);

var _focusable = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\focusable.js");

var _focusable2 = _interopRequireDefault(_focusable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\utilities\\ally.js.focusSource.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _focusSource = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\style\\focus-source.js");

var _focusSource2 = _interopRequireDefault(_focusSource);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _focusSource2.default)();

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\utilities\\index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\utilities\\ally.js.bundle.js");

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\utilities\\ally.js.focusSource.js");

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\element\\focus.svg-foreign-object-hack.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (element) {
  // Edge13, Edge14: foreignObject focus hack
  // https://jsbin.com/kunehinugi/edit?html,js,output
  // https://jsbin.com/fajagi/3/edit?html,js,output
  var isSvgElement = element.ownerSVGElement || element.nodeName.toLowerCase() === 'svg';
  if (!isSvgElement) {
    return false;
  }

  // inject and focus an <input> element into the SVG element to receive focus
  var foreignObject = makeFocusableForeignObject();
  element.appendChild(foreignObject);
  var input = foreignObject.querySelector('input');
  input.focus();

  // upon disabling the activeElement, IE and Edge
  // will not shift focus to <body> like all the other
  // browsers, but instead find the first focusable
  // ancestor and shift focus to that
  input.disabled = true;

  // clean up
  element.removeChild(foreignObject);
  return true;
};

function makeFocusableForeignObject() {
  var fragment = document.createElement('div');
  fragment.innerHTML = '<svg><foreignObject width="30" height="30">\n      <input type="text"/>\n  </foreignObject></svg>';

  return fragment.firstChild.firstChild;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\event\\shadow-focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _activeElements = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\active-elements.js");

var _activeElements2 = _interopRequireDefault(_activeElements);

var _decorateService = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
  Utility to observe focus changes within ShadowDOMs.

  USAGE:
    engage();
    document.body.addEventListener('shadow-focus', function(event) {
      // event.detail.elements: complete focus ancestry (array of nodes)
      // event.detail.active: the actually focused element within the ShadowDOM
      // event.detail.hosts: the shadow host ancestry of the active element
    }, false);

  Alternate implementation: https://github.com/cdata/focus-observer
*/

var engage = void 0;
var disengage = void 0;

if (typeof document === 'undefined' || !document.documentElement.createShadowRoot) {
  // no need to initialize any of this if we don't have ShadowDOM available
  engage = disengage = function disengage() {};
} else {
  var blurTimer = void 0;
  var blurElement = void 0;

  var handleElementBlurEvent = function handleElementBlurEvent() {
    stopHandleElementBlurEvent();
    // abort any handlers that come from document blur handler
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurTimer = (window.setImmediate || window.setTimeout)(function () {
      handleFocusChange();
    });
  };

  var observeElementBlurEvent = function observeElementBlurEvent(element) {
    // call us when we're leaving the element
    element.addEventListener('blur', handleElementBlurEvent, true);
    blurElement = element;
  };

  var stopHandleElementBlurEvent = function stopHandleElementBlurEvent() {
    // once() - sometimes I miss jQuery's simplicity…
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    blurElement = null;
  };

  var handleFocusChange = function handleFocusChange() {
    var _active = (0, _activeElements2.default)();
    if (_active.length === 1) {
      stopHandleElementBlurEvent();
      return;
    }

    // listen for blur so we know when to re-validate
    observeElementBlurEvent(_active[0]);
    var shadowFocusEvent = new CustomEvent('shadow-focus', {
      bubbles: false,
      cancelable: false,
      detail: {
        // complete focus ancestry
        elements: _active,
        // the actually focused element
        active: _active[0],
        // shadow host ancestry
        hosts: _active.slice(1)
      }
    });

    document.dispatchEvent(shadowFocusEvent);
  };

  var handleDocumentFocusEvent = function handleDocumentFocusEvent() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    handleFocusChange();
  };

  engage = function engage() {
    document.addEventListener('focus', handleDocumentFocusEvent, true);
  };

  disengage = function disengage() {
    (window.clearImmediate || window.clearTimeout)(blurTimer);
    blurElement && blurElement.removeEventListener('blur', handleElementBlurEvent, true);
    document.removeEventListener('focus', handleDocumentFocusEvent, true);
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\active-elements.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (document.activeElement === null) {
    // IE10 does not redirect focus to <body> when the activeElement is removed
    document.body.focus();
  }

  // Firefox currently leaks the shadowed element
  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1117535
  if ((0, _shadowed2.default)(document.activeElement)) {
    return walkFromShadowedElement();
  }

  return walkToShadowedElement();
};

var _shadowed = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\shadowed.js");

var _shadowed2 = _interopRequireDefault(_shadowed);

var _shadowHostParents = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\shadow-host-parents.js");

var _shadowHostParents2 = _interopRequireDefault(_shadowHostParents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// [0] always is the actual active element (even within web-components)
// [0+n] is the hierarchy of shadow-doms with [length -1] being the top most shadow-host

function walkToShadowedElement() {
  var list = [document.activeElement];

  while (list[0] && list[0].shadowRoot) {
    list.unshift(list[0].shadowRoot.activeElement);
  }

  return list;
}

function walkFromShadowedElement() {
  var hosts = (0, _shadowHostParents2.default)({ context: document.activeElement });
  return [document.activeElement].concat(hosts);
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\parents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = (0, _contextToElement2.default)({
    label: 'get/parents',
    context: context
  });

  while (element) {
    list.push(element);
    // IE does know support parentElement on SVGElement
    element = element.parentNode;
    if (element && element.nodeType !== Node.ELEMENT_NODE) {
      element = null;
    }
  }

  return list;
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\shadow-host-parents.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var list = [];
  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host-parents',
    context: context
  });

  while (element) {
    element = (0, _shadowHost2.default)({ context: element });
    if (!element) {
      break;
    }

    list.push(element);
  }

  return list;
};

var _shadowHost = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\shadow-host.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context;

  var element = (0, _contextToElement2.default)({
    label: 'get/shadow-host',
    context: context
  });

  // walk up to the root
  var container = null;

  while (element) {
    container = element;
    element = element.parentNode;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Node.nodeType
  // NOTE: Firefox 34 does not expose ShadowRoot.host (but 37 does)
  if (container.nodeType === container.DOCUMENT_FRAGMENT_NODE && container.host) {
    // the root is attached to a fragment node that has a host
    return container.host;
  }

  return null;
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/disabled',
    context: context
  });

  if (element.hasAttribute('data-ally-disabled')) {
    // treat ally's element/disabled like the DOM native element.disabled
    return true;
  }

  if (!(0, _nativeDisabledSupported2.default)(element)) {
    // non-form elements do not support the disabled attribute
    return false;
  }

  if (element.disabled) {
    // the element itself is disabled
    return true;
  }

  var parents = (0, _parents2.default)({ context: element });
  if (parents.some(isDisabledFieldset)) {
    // a parental <fieldset> is disabld and inherits the state onto this element
    return true;
  }

  if (!supports.focusFormDisabled && parents.some(isDisabledForm)) {
    // a parental <form> is disabld and inherits the state onto this element
    return true;
  }

  return false;
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _parents = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _nativeDisabledSupported = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\native-disabled-supported.js");

var _nativeDisabledSupported2 = _interopRequireDefault(_nativeDisabledSupported);

var _supports2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Determine if an element is disabled (i.e. not editable)

var supports = void 0;

function isDisabledFieldset(element) {
  var nodeName = element.nodeName.toLowerCase();
  return nodeName === 'fieldset' && element.disabled;
}

function isDisabledForm(element) {
  var nodeName = element.nodeName.toLowerCase();
  return nodeName === 'form' && element.disabled;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\focus-relevant.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parents = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _elementMatches = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\element-matches.js");

var _elementMatches2 = _interopRequireDefault(_elementMatches);

var _tabindexValue = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _validTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\valid-tabindex.js");

var _validTabindex2 = _interopRequireDefault(_validTabindex);

var _is = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\is.util.js");

var _supports2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;
// determine if an element supports.can be focused by script regardless
// of the element actually being focusable at the time of execution
// i.e. <input disabled> is conisdered focus-relevant, but not focusable

function isFocusRelevantRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    flexbox: false,
    scrollable: false,
    shadow: false
  } : _ref$except;

  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/focus-relevant',
    resolveDocument: true,
    context: context
  });

  if (!except.shadow && element.shadowRoot) {
    // a ShadowDOM host receives focus when the focus moves to its content
    return true;
  }

  var nodeName = element.nodeName.toLowerCase();

  if (nodeName === 'input' && element.type === 'hidden') {
    // input[type="hidden"] supports.cannot be focused
    return false;
  }

  if (nodeName === 'input' || nodeName === 'select' || nodeName === 'button' || nodeName === 'textarea') {
    return true;
  }

  if (nodeName === 'legend' && supports.focusRedirectLegend) {
    // specifics filtered in is/focusable
    return true;
  }

  if (nodeName === 'label') {
    // specifics filtered in is/focusable
    return true;
  }

  if (nodeName === 'area') {
    // specifics filtered in is/focusable
    return true;
  }

  if (nodeName === 'a' && element.hasAttribute('href')) {
    return true;
  }

  if (nodeName === 'object' && element.hasAttribute('usemap')) {
    // object[usemap] is not focusable in any browser
    return false;
  }

  if (nodeName === 'object') {
    var svgType = element.getAttribute('type');
    if (!supports.focusObjectSvg && svgType === 'image/svg+xml') {
      // object[type="image/svg+xml"] is not focusable in Internet Explorer
      return false;
    } else if (!supports.focusObjectSwf && svgType === 'application/x-shockwave-flash') {
      // object[type="application/x-shockwave-flash"] is not focusable in Internet Explorer 9
      return false;
    }
  }

  if (nodeName === 'iframe' || nodeName === 'object') {
    // browsing context containers
    return true;
  }

  if (nodeName === 'embed' || nodeName === 'keygen') {
    // embed is considered focus-relevant but not focusable
    // see https://github.com/medialize/ally.js/issues/82
    return true;
  }

  if (element.hasAttribute('contenteditable')) {
    // also see CSS property user-modify below
    return true;
  }

  if (nodeName === 'audio' && (supports.focusAudioWithoutControls || element.hasAttribute('controls'))) {
    return true;
  }

  if (nodeName === 'video' && (supports.focusVideoWithoutControls || element.hasAttribute('controls'))) {
    return true;
  }

  if (supports.focusSummary && nodeName === 'summary') {
    return true;
  }

  var validTabindex = (0, _validTabindex2.default)(element);

  if (nodeName === 'img' && element.hasAttribute('usemap')) {
    // Gecko, Trident and Edge do not allow an image with an image map and tabindex to be focused,
    // it appears the tabindex is overruled so focus is still forwarded to the <map>
    return validTabindex && supports.focusImgUsemapTabindex || supports.focusRedirectImgUsemap;
  }

  if (supports.focusTable && (nodeName === 'table' || nodeName === 'td')) {
    // IE10-11 supports.can focus <table> and <td>
    return true;
  }

  if (supports.focusFieldset && nodeName === 'fieldset') {
    // IE10-11 supports.can focus <fieldset>
    return true;
  }

  var isSvgElement = nodeName === 'svg';
  var isSvgContent = element.ownerSVGElement;
  var focusableAttribute = element.getAttribute('focusable');
  var tabindex = (0, _tabindexValue2.default)(element);

  if (nodeName === 'use' && tabindex !== null && !supports.focusSvgUseTabindex) {
    // <use> cannot be made focusable by adding a tabindex attribute anywhere but Blink and WebKit
    return false;
  }

  if (nodeName === 'foreignobject') {
    // <use> can only be made focusable in Blink and WebKit
    return tabindex !== null && supports.focusSvgForeignobjectTabindex;
  }

  if ((0, _elementMatches2.default)(element, 'svg a') && element.hasAttribute('xlink:href')) {
    return true;
  }

  if ((isSvgElement || isSvgContent) && element.focus && !supports.focusSvgNegativeTabindexAttribute && tabindex < 0) {
    // Firefox 51 and 52 treat any natively tabbable SVG element with
    // tabindex="-1" as tabbable and everything else as inert
    // see https://bugzilla.mozilla.org/show_bug.cgi?id=1302340
    return false;
  }

  if (isSvgElement) {
    return validTabindex || supports.focusSvg || supports.focusSvgInIframe
    // Internet Explorer understands the focusable attribute introduced in SVG Tiny 1.2
    || Boolean(supports.focusSvgFocusableAttribute && focusableAttribute && focusableAttribute === 'true');
  }

  if (isSvgContent) {
    if (supports.focusSvgTabindexAttribute && validTabindex) {
      return true;
    }

    if (supports.focusSvgFocusableAttribute) {
      // Internet Explorer understands the focusable attribute introduced in SVG Tiny 1.2
      return focusableAttribute === 'true';
    }
  }

  // https://www.w3.org/TR/html5/editing.html#sequential-focus-navigation-and-the-tabindex-attribute
  if (validTabindex) {
    return true;
  }

  var style = window.getComputedStyle(element, null);
  if ((0, _is.isUserModifyWritable)(style)) {
    return true;
  }

  if (supports.focusImgIsmap && nodeName === 'img' && element.hasAttribute('ismap')) {
    // IE10-11 considers the <img> in <a href><img ismap> focusable
    // https://github.com/medialize/ally.js/issues/20
    var hasLinkParent = (0, _parents2.default)({ context: element }).some(function (parent) {
      return parent.nodeName.toLowerCase() === 'a' && parent.hasAttribute('href');
    });

    if (hasLinkParent) {
      return true;
    }
  }

  // https://github.com/medialize/ally.js/issues/21
  if (!except.scrollable && supports.focusScrollContainer) {
    if (supports.focusScrollContainerWithoutOverflow) {
      // Internet Explorer does will consider the scrollable area focusable
      // if the element is a <div> or a <span> and it is in fact scrollable,
      // regardless of the CSS overflow property
      if ((0, _is.isScrollableContainer)(element, nodeName)) {
        return true;
      }
    } else if ((0, _is.hasCssOverflowScroll)(style)) {
      // Firefox requires proper overflow setting, IE does not necessarily
      // https://developer.mozilla.org/en-US/docs/Web/CSS/overflow
      return true;
    }
  }

  if (!except.flexbox && supports.focusFlexboxContainer && (0, _is.hasCssDisplayFlex)(style)) {
    // elements with display:flex are focusable in IE10-11
    return true;
  }

  var parent = element.parentElement;
  if (!except.scrollable && parent) {
    var parentNodeName = parent.nodeName.toLowerCase();
    var parentStyle = window.getComputedStyle(parent, null);
    if (supports.focusScrollBody && (0, _is.isScrollableContainer)(parent, nodeName, parentNodeName, parentStyle)) {
      // scrollable bodies are focusable Internet Explorer
      // https://github.com/medialize/ally.js/issues/21
      return true;
    }

    // Children of focusable elements with display:flex are focusable in IE10-11
    if (supports.focusChildrenOfFocusableFlexbox) {
      if ((0, _is.hasCssDisplayFlex)(parentStyle)) {
        return true;
      }
    }
  }

  // NOTE: elements marked as inert are not focusable,
  // but that property is not exposed to the DOM
  // https://www.w3.org/TR/html5/editing.html#inert

  return false;
}

// bind exceptions to an iterator callback
isFocusRelevantRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isFocusRelevant = function isFocusRelevant(context) {
    return isFocusRelevantRules({
      context: context,
      except: except
    });
  };

  isFocusRelevant.rules = isFocusRelevantRules;
  return isFocusRelevant;
};

// provide isFocusRelevant(context) as default iterator callback
var isFocusRelevant = isFocusRelevantRules.except({});
exports.default = isFocusRelevant;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\focusable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _focusRelevant = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\focus-relevant.js");

var _focusRelevant2 = _interopRequireDefault(_focusRelevant);

var _validArea = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\valid-area.js");

var _validArea2 = _interopRequireDefault(_validArea);

var _visible = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\visible.js");

var _visible2 = _interopRequireDefault(_visible);

var _disabled = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\disabled.js");

var _disabled2 = _interopRequireDefault(_disabled);

var _onlyTabbable = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\only-tabbable.js");

var _onlyTabbable2 = _interopRequireDefault(_onlyTabbable);

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getFrameElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-frame-element.js");

var _getFrameElement2 = _interopRequireDefault(_getFrameElement);

var _tabindexValue = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _supports2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;
// determine if an element can be focused

// https://www.w3.org/TR/html5/editing.html#focus-management

// NOTE: The following known issues exist:
//   Gecko: `svg a[xlink|href]` is not identified as focusable (because SVGElement.prototype.focus is missing)
//   Blink, WebKit: SVGElements that have been made focusable by adding a focus event listener are not identified as focusable

function isOnlyFocusRelevant(element) {
  var nodeName = element.nodeName.toLowerCase();
  if (nodeName === 'embed' || nodeName === 'keygen') {
    // embed is considered focus-relevant but not focusable
    // see https://github.com/medialize/ally.js/issues/82
    return true;
  }

  var _tabindex = (0, _tabindexValue2.default)(element);
  if (element.shadowRoot && _tabindex === null) {
    // ShadowDOM host elements *may* receive focus
    // even though they are not considered focuable
    return true;
  }

  if (nodeName === 'label') {
    // <label tabindex="0"> is only tabbable in Firefox, not script-focusable
    // there's no way to make an element focusable other than by adding a tabindex,
    // and focus behavior of the label element seems hard-wired to ignore tabindex
    // in some browsers (like Gecko, Blink and WebKit)
    return !supports.focusLabelTabindex || _tabindex === null;
  }

  if (nodeName === 'legend') {
    return _tabindex === null;
  }

  if (supports.focusSvgFocusableAttribute && (element.ownerSVGElement || nodeName === 'svg')) {
    // Internet Explorer understands the focusable attribute introduced in SVG Tiny 1.2
    var focusableAttribute = element.getAttribute('focusable');
    return focusableAttribute && focusableAttribute === 'false';
  }

  if (nodeName === 'img' && element.hasAttribute('usemap')) {
    // Gecko, Trident and Edge do not allow an image with an image map and tabindex to be focused,
    // it appears the tabindex is overruled so focus is still forwarded to the <map>
    return _tabindex === null || !supports.focusImgUsemapTabindex;
  }

  if (nodeName === 'area') {
    // all <area>s are considered relevant,
    // but only the valid <area>s are focusable
    return !(0, _validArea2.default)(element);
  }

  return false;
}

function isFocusableRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    disabled: false,
    visible: false,
    onlyTabbable: false
  } : _ref$except;

  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var _isOnlyTabbable = _onlyTabbable2.default.rules.except({
    onlyFocusableBrowsingContext: true,
    visible: except.visible
  });

  var element = (0, _contextToElement2.default)({
    label: 'is/focusable',
    resolveDocument: true,
    context: context
  });

  var focusRelevant = _focusRelevant2.default.rules({
    context: element,
    except: except
  });

  if (!focusRelevant || isOnlyFocusRelevant(element)) {
    return false;
  }

  if (!except.disabled && (0, _disabled2.default)(element)) {
    return false;
  }

  if (!except.onlyTabbable && _isOnlyTabbable(element)) {
    // some elements may be keyboard focusable, but not script focusable
    return false;
  }

  // elements that are not rendered, cannot be focused
  if (!except.visible) {
    var visibilityOptions = {
      context: element,
      except: {}
    };

    if (supports.focusInHiddenIframe) {
      // WebKit and Blink can focus content in hidden <iframe> and <object>
      visibilityOptions.except.browsingContext = true;
    }

    if (supports.focusObjectSvgHidden) {
      // Blink allows focusing the object element, even if it has visibility: hidden;
      // @browser-issue Blink https://code.google.com/p/chromium/issues/detail?id=586191
      var _nodeName2 = element.nodeName.toLowerCase();
      if (_nodeName2 === 'object') {
        visibilityOptions.except.cssVisibility = true;
      }
    }

    if (!_visible2.default.rules(visibilityOptions)) {
      return false;
    }
  }

  var frameElement = (0, _getFrameElement2.default)(element);
  if (frameElement) {
    var _nodeName = frameElement.nodeName.toLowerCase();
    if (_nodeName === 'object' && !supports.focusInZeroDimensionObject) {
      if (!frameElement.offsetWidth || !frameElement.offsetHeight) {
        // WebKit can not focus content in <object> if it doesn't have dimensions
        return false;
      }
    }
  }

  var nodeName = element.nodeName.toLowerCase();
  if (nodeName === 'svg' && supports.focusSvgInIframe && !frameElement && element.getAttribute('tabindex') === null) {
    return false;
  }

  return true;
}

// bind exceptions to an iterator callback
isFocusableRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isFocusable = function isFocusable(context) {
    return isFocusableRules({
      context: context,
      except: except
    });
  };

  isFocusable.rules = isFocusableRules;
  return isFocusable;
};

// provide isFocusRelevant(context) as default iterator callback
var isFocusable = isFocusableRules.except({});
exports.default = isFocusable;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\is.util.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserModifyWritable = isUserModifyWritable;
exports.hasCssOverflowScroll = hasCssOverflowScroll;
exports.hasCssDisplayFlex = hasCssDisplayFlex;
exports.isScrollableContainer = isScrollableContainer;

// this is a shared utility file for focus-relevant.js and tabbable.js
// separate testing of this file's functions is not necessary,
// as they're implicitly tested by way of the consumers

function isUserModifyWritable(style) {
  // https://www.w3.org/TR/1999/WD-css3-userint-19990916#user-modify
  // https://github.com/medialize/ally.js/issues/17
  var userModify = style.webkitUserModify || '';
  return Boolean(userModify && userModify.indexOf('write') !== -1);
}

function hasCssOverflowScroll(style) {
  return [style.getPropertyValue('overflow'), style.getPropertyValue('overflow-x'), style.getPropertyValue('overflow-y')].some(function (overflow) {
    return overflow === 'auto' || overflow === 'scroll';
  });
}

function hasCssDisplayFlex(style) {
  return style.display.indexOf('flex') > -1;
}

function isScrollableContainer(element, nodeName, parentNodeName, parentStyle) {
  if (nodeName !== 'div' && nodeName !== 'span') {
    // Internet Explorer advances scrollable containers and bodies to focusable
    // only if the scrollable container is <div> or <span> - this does *not*
    // happen for <section>, <article>, …
    return false;
  }

  if (parentNodeName && parentNodeName !== 'div' && parentNodeName !== 'span' && !hasCssOverflowScroll(parentStyle)) {
    return false;
  }

  return element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\native-disabled-supported.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();

    if (supports.focusFieldsetDisabled) {
      delete disabledElements.fieldset;
    }

    if (supports.focusFormDisabled) {
      delete disabledElements.form;
    }

    disabledElementsPattern = new RegExp('^(' + Object.keys(disabledElements).join('|') + ')$');
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/native-disabled-supported',
    context: context
  });

  var nodeName = element.nodeName.toLowerCase();
  return Boolean(disabledElementsPattern.test(nodeName));
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _supports2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Determine if an element supports the disabled attribute

var supports = void 0;

// https://www.w3.org/TR/html5/disabled-elements.html#concept-element-disabled
var disabledElementsPattern = void 0;
var disabledElements = {
  input: true,
  select: true,
  textarea: true,
  button: true,
  fieldset: true,
  form: true
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\only-tabbable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _visible = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\visible.js");

var _visible2 = _interopRequireDefault(_visible);

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getFrameElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-frame-element.js");

var _getFrameElement2 = _interopRequireDefault(_getFrameElement);

var _tabindexValue = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\tabindex-value.js");

var _tabindexValue2 = _interopRequireDefault(_tabindexValue);

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isOnlyTabbableRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    onlyFocusableBrowsingContext: false,
    visible: false
  } : _ref$except;

  var element = (0, _contextToElement2.default)({
    label: 'is/only-tabbable',
    resolveDocument: true,
    context: context
  });

  if (!except.visible && !(0, _visible2.default)(element)) {
    return false;
  }

  if (!except.onlyFocusableBrowsingContext && (_platform2.default.is.GECKO || _platform2.default.is.TRIDENT || _platform2.default.is.EDGE)) {
    var frameElement = (0, _getFrameElement2.default)(element);
    if (frameElement) {
      if ((0, _tabindexValue2.default)(frameElement) < 0) {
        // iframe[tabindex="-1"] and object[tabindex="-1"] inherit the
        // tabbable demotion onto elements of their browsing contexts
        return false;
      }
    }
  }

  var nodeName = element.nodeName.toLowerCase();
  var tabindex = (0, _tabindexValue2.default)(element);

  if (nodeName === 'label' && _platform2.default.is.GECKO) {
    // Firefox cannot focus, but tab to: label[tabindex=0]
    return tabindex !== null && tabindex >= 0;
  }

  // SVG Elements were keyboard focusable but not script focusable before Firefox 51.
  // Firefox 51 added the focus management DOM API (.focus and .blur) to SVGElement,
  // see https://bugzilla.mozilla.org/show_bug.cgi?id=778654
  if (_platform2.default.is.GECKO && element.ownerSVGElement && !element.focus) {
    if (nodeName === 'a' && element.hasAttribute('xlink:href')) {
      // any focusable child of <svg> cannot be focused, but tabbed to
      if (_platform2.default.is.GECKO) {
        return true;
      }
    }
  }

  return false;
}

// bind exceptions to an iterator callback
isOnlyTabbableRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isOnlyTabbable = function isOnlyTabbable(context) {
    return isOnlyTabbableRules({
      context: context,
      except: except
    });
  };

  isOnlyTabbable.rules = isOnlyTabbableRules;
  return isOnlyTabbable;
};

// provide isOnlyTabbable(context) as default iterator callback
var isOnlyTabbable = isOnlyTabbableRules.except({});
exports.default = isOnlyTabbable;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\shadowed.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  var element = (0, _contextToElement2.default)({
    label: 'is/shadowed',
    resolveDocument: true,
    context: context
  });

  return Boolean((0, _shadowHost2.default)({ context: element }));
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _shadowHost = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\shadow-host.js");

var _shadowHost2 = _interopRequireDefault(_shadowHost);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\valid-area.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var element = (0, _contextToElement2.default)({
    label: 'is/valid-area',
    context: context
  });

  var nodeName = element.nodeName.toLowerCase();
  if (nodeName !== 'area') {
    return false;
  }

  var hasTabindex = element.hasAttribute('tabindex');
  if (!supports.focusAreaTabindex && hasTabindex) {
    // Blink and WebKit do not consider <area tabindex="-1" href="#void"> focusable
    return false;
  }

  var img = (0, _imageMap.getImageOfArea)(element);
  if (!img || !(0, _visible2.default)(img)) {
    return false;
  }

  // Firefox only allows fully loaded images to reference image maps
  // https://stereochro.me/ideas/detecting-broken-images-js
  if (!supports.focusBrokenImageMap && (!img.complete || !img.naturalHeight || img.offsetWidth <= 0 || img.offsetHeight <= 0)) {
    return false;
  }

  // Firefox supports.can focus area elements even if they don't have an href attribute
  if (!supports.focusAreaWithoutHref && !element.href) {
    // Internet explorer supports.can focus area elements without href if either
    // the area element or the image element has a tabindex attribute
    return supports.focusAreaTabindex && hasTabindex || supports.focusAreaImgTabindex && img.hasAttribute('tabindex');
  }

  // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
  var childOfInteractive = (0, _parents2.default)({ context: img }).slice(1).some(function (_element) {
    var name = _element.nodeName.toLowerCase();
    return name === 'button' || name === 'a';
  });

  if (childOfInteractive) {
    return false;
  }

  return true;
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _visible = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\visible.js");

var _visible2 = _interopRequireDefault(_visible);

var _parents = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _imageMap = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\image-map.js");

var _supports2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var supports = void 0;

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/map
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
// https://github.com/jquery/jquery-ui/blob/master/ui/core.js#L88-L107

// determine if an <area> element is being properly used by and <img> via a <map>

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\valid-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (context) {
  if (!supports) {
    supports = (0, _supports3.default)();
  }

  var validIntegerPattern = supports.focusTabindexTrailingCharacters ? validIntegerPatternWithTrailing : validIntegerPatternNoTrailing;

  var element = (0, _contextToElement2.default)({
    label: 'is/valid-tabindex',
    resolveDocument: true,
    context: context
  });

  // Edge 14 has a capitalization problem on SVG elements,
  // see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9282058/
  var hasTabindex = element.hasAttribute('tabindex');
  var hasTabIndex = element.hasAttribute('tabIndex');

  if (!hasTabindex && !hasTabIndex) {
    return false;
  }

  // older Firefox and Internet Explorer don't support tabindex on SVG elements
  var isSvgElement = element.ownerSVGElement || element.nodeName.toLowerCase() === 'svg';
  if (isSvgElement && !supports.focusSvgTabindexAttribute) {
    return false;
  }

  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
  if (supports.focusInvalidTabindex) {
    return true;
  }

  // an element matches the tabindex selector even if its value is invalid
  var tabindex = element.getAttribute(hasTabindex ? 'tabindex' : 'tabIndex');
  // IE11 parses tabindex="" as the value "-32768"
  // @browser-issue Trident https://connect.microsoft.com/IE/feedback/details/1072965
  if (tabindex === '-32768') {
    return false;
  }

  return Boolean(tabindex && validIntegerPattern.test(tabindex));
};

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _supports2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js");

var _supports3 = _interopRequireDefault(_supports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// determine if an element's tabindex attribute has a valid value

var supports = void 0;

// https://www.w3.org/TR/html5/infrastructure.html#rules-for-parsing-integers
// NOTE: all browsers agree to allow trailing spaces as well
var validIntegerPatternNoTrailing = /^\s*(-|\+)?[0-9]+\s*$/;
var validIntegerPatternWithTrailing = /^\s*(-|\+)?[0-9]+.*$/;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\visible.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _arrayFindIndex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\array-find-index.js");

var _arrayFindIndex2 = _interopRequireDefault(_arrayFindIndex);

var _parents = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\get\\parents.js");

var _parents2 = _interopRequireDefault(_parents);

var _contextToElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js");

var _contextToElement2 = _interopRequireDefault(_contextToElement);

var _getFrameElement = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-frame-element.js");

var _getFrameElement2 = _interopRequireDefault(_getFrameElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.w3.org/TR/html5/rendering.html#being-rendered
// <area> is not rendered, but we *consider* it visible to simplfiy this function's usage

// determine if an element is rendered
// NOTE: that does not mean an element is visible in the viewport, see util/visible-area

var notRenderedElementsPattern = /^(area)$/;

function computedStyle(element, property) {
  return window.getComputedStyle(element, null).getPropertyValue(property);
}

function notDisplayed(_path) {
  return _path.some(function (element) {
    // display:none is not visible (optimized away at layout)
    return computedStyle(element, 'display') === 'none';
  });
}

function notVisible(_path) {
  // https://github.com/jquery/jquery-ui/blob/master/ui/core.js#L109-L114
  // NOTE: a nested element can reverse visibility:hidden|collapse by explicitly setting visibility:visible
  // NOTE: visibility can be ["", "visible", "hidden", "collapse"]
  var hidden = (0, _arrayFindIndex2.default)(_path, function (element) {
    var visibility = computedStyle(element, 'visibility');
    return visibility === 'hidden' || visibility === 'collapse';
  });

  if (hidden === -1) {
    // there is no hidden element
    return false;
  }

  var visible = (0, _arrayFindIndex2.default)(_path, function (element) {
    return computedStyle(element, 'visibility') === 'visible';
  });

  if (visible === -1) {
    // there is no visible element (but a hidden element)
    return true;
  }

  if (hidden < visible) {
    // there is a hidden element and it's closer than the first visible element
    return true;
  }

  // there may be a hidden element, but the closest element is visible
  return false;
}

function collapsedParent(_path) {
  var offset = 1;
  if (_path[0].nodeName.toLowerCase() === 'summary') {
    offset = 2;
  }

  return _path.slice(offset).some(function (element) {
    // "content children" of a closed details element are not visible
    return element.nodeName.toLowerCase() === 'details' && element.open === false;
  });
}

function isVisibleRules() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref.context,
      _ref$except = _ref.except,
      except = _ref$except === undefined ? {
    notRendered: false,
    cssDisplay: false,
    cssVisibility: false,
    detailsElement: false,
    browsingContext: false
  } : _ref$except;

  var element = (0, _contextToElement2.default)({
    label: 'is/visible',
    resolveDocument: true,
    context: context
  });

  var nodeName = element.nodeName.toLowerCase();
  if (!except.notRendered && notRenderedElementsPattern.test(nodeName)) {
    return true;
  }

  var _path = (0, _parents2.default)({ context: element });

  // in Internet Explorer <audio> has a default display: none, where others have display: inline
  // but IE allows focusing <audio style="display:none">, but not <div display:none><audio>
  // this is irrelevant to other browsers, as the controls attribute is required to make <audio> focusable
  var isAudioWithoutControls = nodeName === 'audio' && !element.hasAttribute('controls');
  if (!except.cssDisplay && notDisplayed(isAudioWithoutControls ? _path.slice(1) : _path)) {
    return false;
  }

  if (!except.cssVisibility && notVisible(_path)) {
    return false;
  }

  if (!except.detailsElement && collapsedParent(_path)) {
    return false;
  }

  if (!except.browsingContext) {
    // elements within a browsing context are affected by the
    // browsing context host element's visibility and tabindex
    var frameElement = (0, _getFrameElement2.default)(element);
    var _isVisible = isVisibleRules.except(except);
    if (frameElement && !_isVisible(frameElement)) {
      return false;
    }
  }

  return true;
}

// bind exceptions to an iterator callback
isVisibleRules.except = function () {
  var except = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var isVisible = function isVisible(context) {
    return isVisibleRules({
      context: context,
      except: except
    });
  };

  isVisible.rules = isVisibleRules;
  return isVisible;
};

// provide isVisible(context) as default iterator callback
var isVisible = isVisibleRules.except({});
exports.default = isVisible;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\map\\keycode.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// codes mostly cloned from https://github.com/keithamus/jwerty/blob/master/jwerty.js
// deliberately not exposing characters like <,.-#* because they vary *wildly*
// across keyboard layouts and may cause various problems
// (e.g. "*" is "Shift +" on a German Mac keyboard)
// (e.g. "@" is "Alt L" on a German Mac keyboard)

var keycode = {
  // Element Focus
  tab: 9,

  // Navigation
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  pageUp: 33,
  'page-up': 33,
  pageDown: 34,
  'page-down': 34,
  end: 35,
  home: 36,

  // Action
  enter: 13,
  escape: 27,
  space: 32,

  // Modifier
  shift: 16,
  capsLock: 20,
  'caps-lock': 20,
  ctrl: 17,
  alt: 18,
  meta: 91,
  // in firefox: 224
  // on mac (chrome): meta-left=91, meta-right=93
  // on win (IE11): meta-left=91, meta-right=92
  pause: 19,

  // Content Manipulation
  insert: 45,
  'delete': 46,
  backspace: 8,

  // the same logical key may be identified through different keyCodes
  _alias: {
    91: [92, 93, 224]
  }
};

// Function keys (112 - 137)
// NOTE: not every keyboard knows F13+
for (var n = 1; n < 26; n++) {
  keycode['f' + n] = n + 111;
}

// Number keys (48-57, numpad 96-105)
// NOTE: not every keyboard knows num-0+
for (var _n = 0; _n < 10; _n++) {
  var code = _n + 48;
  var numCode = _n + 96;
  keycode[_n] = code;
  keycode['num-' + _n] = numCode;
  keycode._alias[code] = [numCode];
}

// Latin characters (65 - 90)
for (var _n2 = 0; _n2 < 26; _n2++) {
  var _code = _n2 + 65;
  var name = String.fromCharCode(_code).toLowerCase();
  keycode[name] = _code;
}

exports.default = keycode;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\observe\\interaction-type.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _decorateService = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// counters to track primary input
var _activePointers = 0;
/*
  Observe keyboard-, pointer-, mouse- and touch-events so that a query for
  the current interaction type can be made at any time. For pointer interaction
  this observer is limited to pointer button down/up - move is not observed!

  USAGE:
    var listener = engage();
    listener.get() === {pointer: Boolean, key: Boolean}
*/

var _activeKeys = 0;

var pointerStartEvents = ['touchstart', 'pointerdown', 'MSPointerDown', 'mousedown'];
var pointerEndEvents = ['touchend', 'touchcancel', 'pointerup', 'MSPointerUp', 'pointercancel', 'MSPointerCancel', 'mouseup'];

function handleWindowBlurEvent() {
  // reset internal counters when window loses focus
  _activePointers = 0;
  _activeKeys = 0;
}

function handlePointerStartEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  }

  // mousedown without following mouseup
  // (likely not possible in Chrome)
  _activePointers++;
}

function handlePointerEndEvent(event) {
  if (event.isPrimary === false) {
    // ignore non-primary pointer events
    // https://w3c.github.io/pointerevents/#widl-PointerEvent-isPrimary
    return;
  } else if (event.touches) {
    _activePointers = event.touches.length;
    return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // mouseup without prior mousedown
    // (drag something out of the window)
    _activePointers = Math.max(_activePointers - 1, 0);
  });
}

function handleKeyStartEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // keydown without a following keyup
  // (may happen on CMD+TAB)
  _activeKeys++;
}

function handleKeyEndEvent(event) {
  // ignore modifier keys
  switch (event.keyCode || event.which) {
    case 16: // space
    case 17: // control
    case 18: // alt
    case 91: // command left
    case 93:
      // command right
      return;
  }

  // delay reset to when the current handlers are executed
  (window.setImmediate || window.setTimeout)(function () {
    // keyup without prior keydown
    // (may happen on CMD+R)
    _activeKeys = Math.max(_activeKeys - 1, 0);
  });
}

function getInteractionType() {
  return {
    pointer: Boolean(_activePointers),
    key: Boolean(_activeKeys)
  };
}

function disengage() {
  _activePointers = _activeKeys = 0;
  window.removeEventListener('blur', handleWindowBlurEvent, false);
  document.documentElement.removeEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.removeEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.removeEventListener(event, handlePointerEndEvent, true);
  });
}

function engage() {
  // window blur must be in bubble phase so it won't capture regular blurs
  window.addEventListener('blur', handleWindowBlurEvent, false);
  // handlers to identify the method of focus change
  document.documentElement.addEventListener('keydown', handleKeyStartEvent, true);
  document.documentElement.addEventListener('keyup', handleKeyEndEvent, true);
  pointerStartEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerStartEvent, true);
  });
  pointerEndEvents.forEach(function (event) {
    document.documentElement.addEventListener(event, handlePointerEndEvent, true);
  });

  return {
    get: getInteractionType
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\style\\focus-source.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toggleClass = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\toggle-class.js");

var _shadowFocus = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\event\\shadow-focus.js");

var _shadowFocus2 = _interopRequireDefault(_shadowFocus);

var _interactionType = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\observe\\interaction-type.js");

var _interactionType2 = _interopRequireDefault(_interactionType);

var _decorateService = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\decorate-service.js");

var _decorateService2 = _interopRequireDefault(_decorateService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// preferring focusin/out because they are synchronous in IE10+11

/*
  add data-focus-source attribute to html element containing "key", "pointer" or "script"
  depending on the input method used to change focus.

  USAGE:
    style/focus-source()

    body :focus {
      outline: 1px solid grey;
    }

    html[data-focus-source="key"] body :focus {
      outline: 5px solid red;
    }

    html[data-focus-source="key"] body :focus {
      outline: 1px solid blue;
    }

  NOTE: I don't have a GamePad to test, if you do and you want to
  implement an observer for https://w3c.github.io/gamepad/ - send a PR!

  Alternate implementation: https://github.com/alice/modality
*/

var supportsFocusIn = typeof document !== 'undefined' && 'onfocusin' in document;
var focusEventName = supportsFocusIn ? 'focusin' : 'focus';
var blurEventName = supportsFocusIn ? 'focusout' : 'blur';

// interface to read interaction-type-listener state
var interactionTypeHandler = void 0;
var shadowHandle = void 0;
// keep track of last focus source
var current = null;
// overwrite focus source for use with the every upcoming focus event
var lock = null;
// keep track of ever having used a particular input method to change focus
var used = {
  pointer: false,
  key: false,
  script: false,
  initial: false
};

function handleFocusEvent(event) {
  var source = '';
  if (event.type === focusEventName || event.type === 'shadow-focus') {
    var interactionType = interactionTypeHandler.get();
    source = lock || interactionType.pointer && 'pointer' || interactionType.key && 'key' || 'script';
  } else if (event.type === 'initial') {
    source = 'initial';
  }

  document.documentElement.setAttribute('data-focus-source', source);

  if (event.type !== blurEventName) {
    if (!used[source]) {
      (0, _toggleClass.addClass)(document.documentElement, 'focus-source-' + source);
    }

    used[source] = true;
    current = source;
  }
}

function getCurrentFocusSource() {
  return current;
}

function getUsedFocusSource(source) {
  return used[source];
}

function lockFocusSource(source) {
  lock = source;
}

function unlockFocusSource() {
  lock = false;
}

function disengage() {
  // clear dom state
  handleFocusEvent({ type: blurEventName });
  current = lock = null;
  Object.keys(used).forEach(function (key) {
    (0, _toggleClass.removeClass)(document.documentElement, 'focus-source-' + key);
    used[key] = false;
  });
  // kill interaction type identification listener
  interactionTypeHandler.disengage();
  // kill shadow-focus event dispatcher
  shadowHandle && shadowHandle.disengage();
  document.removeEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.removeEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.removeEventListener(blurEventName, handleFocusEvent, true);
  document.documentElement.removeAttribute('data-focus-source');
}

function engage() {
  // enable the shadow-focus event dispatcher
  shadowHandle = (0, _shadowFocus2.default)();
  // handlers to modify the focused element
  document.addEventListener('shadow-focus', handleFocusEvent, true);
  document.documentElement.addEventListener(focusEventName, handleFocusEvent, true);
  document.documentElement.addEventListener(blurEventName, handleFocusEvent, true);
  // enable the interaction type identification observer
  interactionTypeHandler = (0, _interactionType2.default)();
  // set up initial dom state
  handleFocusEvent({ type: 'initial' });

  return {
    used: getUsedFocusSource,
    current: getCurrentFocusSource,
    lock: lockFocusSource,
    unlock: unlockFocusSource
  };
}

exports.default = (0, _decorateService2.default)({ engage: engage, disengage: disengage });

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\css-shadow-piercing-deep-combinator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var combinator = void 0;

  // see https://dev.w3.org/csswg/css-scoping-1/#deep-combinator
  // https://bugzilla.mozilla.org/show_bug.cgi?id=1117572
  // https://code.google.com/p/chromium/issues/detail?id=446051
  try {
    document.querySelector('html >>> :first-child');
    combinator = '>>>';
  } catch (noArrowArrowArrow) {
    try {
      // old syntax supported at least up to Chrome 41
      // https://code.google.com/p/chromium/issues/detail?id=446051
      document.querySelector('html /deep/ :first-child');
      combinator = '/deep/';
    } catch (noDeep) {
      combinator = '';
    }
  }

  return combinator;
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\detect-focus.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (tests) {
  var data = before();

  var results = {};
  Object.keys(tests).map(function (key) {
    results[key] = test(data, tests[key]);
  });

  after(data);
  return results;
};

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function before() {
  var data = {
    // remember what had focus to restore after test
    activeElement: document.activeElement,
    // remember scroll positions to restore after test
    windowScrollTop: window.scrollTop,
    windowScrollLeft: window.scrollLeft,
    bodyScrollTop: document.body.scrollTop,
    bodyScrollLeft: document.body.scrollLeft
  };

  // wrap tests in an element hidden from screen readers to prevent them
  // from announcing focus, which can be quite irritating to the user
  var iframe = document.createElement('iframe');
  iframe.setAttribute('style', 'position:absolute; position:fixed; top:0; left:-2px; width:1px; height:1px; overflow:hidden;');
  iframe.setAttribute('aria-live', 'off');
  iframe.setAttribute('aria-busy', 'true');
  iframe.setAttribute('aria-hidden', 'true');
  document.body.appendChild(iframe);

  var _window = iframe.contentWindow;
  var _document = _window.document;

  _document.open();
  _document.close();
  var wrapper = _document.createElement('div');
  _document.body.appendChild(wrapper);

  data.iframe = iframe;
  data.wrapper = wrapper;
  data.window = _window;
  data.document = _document;

  return data;
}

// options.element:
//  {string} element name
//  {function} callback(wrapper, document) to generate an element
// options.mutate: (optional)
//  {function} callback(element, wrapper, document) to manipulate element prior to focus-test.
//             Can return DOMElement to define focus target (default: element)
// options.validate: (optional)
//  {function} callback(element, focusTarget, document) to manipulate test-result
function test(data, options) {
  // make sure we operate on a clean slate
  data.wrapper.innerHTML = '';
  // create dummy element to test focusability of
  var element = typeof options.element === 'string' ? data.document.createElement(options.element) : options.element(data.wrapper, data.document);
  // allow callback to further specify dummy element
  // and optionally define element to focus
  var focus = options.mutate && options.mutate(element, data.wrapper, data.document);
  if (!focus && focus !== false) {
    focus = element;
  }
  // element needs to be part of the DOM to be focusable
  !element.parentNode && data.wrapper.appendChild(element);
  // test if the element with invalid tabindex can be focused
  focus && focus.focus && focus.focus();
  // validate test's result
  return options.validate ? options.validate(element, focus, data.document) : data.document.activeElement === focus;
}

function after(data) {
  // restore focus to what it was before test and cleanup
  if (data.activeElement === document.body) {
    document.activeElement && document.activeElement.blur && document.activeElement.blur();
    if (_platform2.default.is.IE10) {
      // IE10 does not redirect focus to <body> when the activeElement is removed
      document.body.focus();
    }
  } else {
    data.activeElement && data.activeElement.focus && data.activeElement.focus();
  }

  document.body.removeChild(data.iframe);

  // restore scroll position
  window.scrollTop = data.windowScrollTop;
  window.scrollLeft = data.windowScrollLeft;
  document.body.scrollTop = data.bodyScrollTop;
  document.body.scrollLeft = data.bodyScrollLeft;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-area-img-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" src="' + _gif2.default + '">';

    return element.querySelector('area');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-area-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test">' + '<area href="#void" tabindex="-1" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" alt="" src="' + _gif2.default + '">';

    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    if (_platform2.default.is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    var focus = element.querySelector('area');
    focus.focus();
    return _document.activeElement === focus;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-area-without-href.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-area-href-test">' + '<area shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-area-href-test" alt="" src="' + _gif2.default + '">';

    return element.querySelector('area');
  },
  validate: function validate(element, focusTarget, _document) {
    if (_platform2.default.is.GECKO) {
      // fixes https://github.com/medialize/ally.js/issues/35
      // Firefox loads the DataURI asynchronously, causing a false-negative
      return true;
    }

    return _document.activeElement === focusTarget;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-audio-without-controls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mp = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\mp3.js");

var _mp2 = _interopRequireDefault(_mp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'can-focus-audio-without-controls',
  element: 'audio',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', _mp2.default);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-broken-image-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.invalid.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="broken-image-map-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#broken-image-map-test" alt="" src="' + _gif2.default + '">';

    return element.querySelector('area');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-children-of-focusable-flexbox.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Children of focusable elements with display:flex are focusable in IE10-11
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
    return element.querySelector('span');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-fieldset-disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// fieldset[tabindex=0][disabled] should not be focusable, but Blink and WebKit disagree
// @specification https://www.w3.org/TR/html5/disabled-elements.html#concept-element-disabled
// @browser-issue Chromium https://crbug.com/453847
// @browser-issue WebKit https://bugs.webkit.org/show_bug.cgi?id=141086
exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-fieldset.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><p>content</p>';
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-flexbox-container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// elements with display:flex are focusable in IE10-11
exports.default = {
  element: 'span',
  mutate: function mutate(element) {
    element.setAttribute('style', 'display: -webkit-flex; display: -ms-flexbox; display: flex;');
    element.innerHTML = '<span style="display: block;">hello</span>';
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-form-disabled.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// form[tabindex=0][disabled] should be focusable as the
// specification doesn't know the disabled attribute on the form element
// @specification https://www.w3.org/TR/html5/forms.html#the-form-element
exports.default = {
  element: 'form',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 0);
    element.setAttribute('disabled', 'disabled');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-img-ismap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: https://github.com/medialize/ally.js/issues/35
// fixes https://github.com/medialize/ally.js/issues/20
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-ismap
exports.default = {
  element: 'a',
  mutate: function mutate(element) {
    element.href = '#void';
    element.innerHTML = '<img ismap src="' + _gif2.default + '" alt="">';
    return element.querySelector('img');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-img-usemap-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// NOTE: https://github.com/medialize/ally.js/issues/35
// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attr-usemap
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="image-map-tabindex-test"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#image-map-tabindex-test" tabindex="-1" alt="" ' + 'src="' + _gif2.default + '">';

    return element.querySelector('img');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-in-hidden-iframe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: function element(wrapper, _document) {
    var iframe = _document.createElement('iframe');

    // iframe must be part of the DOM before accessing the contentWindow is possible
    wrapper.appendChild(iframe);

    // create the iframe's default document (<html><head></head><body></body></html>)
    var iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.close();
    return iframe;
  },
  mutate: function mutate(iframe) {
    iframe.style.visibility = 'hidden';

    var iframeDocument = iframe.contentWindow.document;
    var input = iframeDocument.createElement('input');
    iframeDocument.body.appendChild(input);
    return input;
  },
  validate: function validate(iframe) {
    var iframeDocument = iframe.contentWindow.document;
    var focus = iframeDocument.querySelector('input');
    return iframeDocument.activeElement === focus;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-in-zero-dimension-object.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var result = !_platform2.default.is.WEBKIT;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-invalid-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', 'invalid-value');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-label-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'label',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '-1');
  },
  validate: function validate(element, focusTarget, _document) {
    // force layout in Chrome 49, otherwise the element won't be focusable
    /* eslint-disable no-unused-vars */
    var variableToPreventDeadCodeElimination = element.offsetHeight;
    /* eslint-enable no-unused-vars */
    element.focus();
    return _document.activeElement === element;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-object-svg-hidden.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\svg.js");

var _svg2 = _interopRequireDefault(_svg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: IE10 on BrowserStack does not like this test

exports.default = {
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', _svg2.default);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
    element.style.visibility = 'hidden';
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-object-svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\svg.js");

var _svg2 = _interopRequireDefault(_svg);

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Note: IE10 on BrowserStack does not like this test

exports.default = {
  name: 'can-focus-object-svg',
  element: 'object',
  mutate: function mutate(element) {
    element.setAttribute('type', 'image/svg+xml');
    element.setAttribute('data', _svg2.default);
    element.setAttribute('width', '200');
    element.setAttribute('height', '50');
  },
  validate: function validate(element, focusTarget, _document) {
    if (_platform2.default.is.GECKO) {
      // Firefox seems to be handling the object creation asynchronously and thereby produces a false negative test result.
      // Because we know Firefox is able to focus object elements referencing SVGs, we simply cheat by sniffing the user agent string
      return true;
    }

    return _document.activeElement === element;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-object-swf.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Every Environment except IE9 considers SWF objects focusable
var result = !_platform2.default.is.IE9;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-redirect-img-usemap.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = '<map name="focus-redirect-img-usemap"><area href="#void" shape="rect" coords="63,19,144,45"></map>' + '<img usemap="#focus-redirect-img-usemap" alt="" ' + 'src="' + _gif2.default + '">';

    // focus the <img>, not the <div>
    return element.querySelector('img');
  },
  validate: function validate(element, focusTarget, _document) {
    var target = element.querySelector('area');
    return _document.activeElement === target;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-redirect-legend.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// see https://jsbin.com/nenirisage/edit?html,js,console,output

exports.default = {
  element: 'fieldset',
  mutate: function mutate(element) {
    element.innerHTML = '<legend>legend</legend><input tabindex="-1"><input tabindex="0">';
    // take care of focus in validate();
    return false;
  },
  validate: function validate(element, focusTarget, _document) {
    var focusable = element.querySelector('input[tabindex="-1"]');
    var tabbable = element.querySelector('input[tabindex="0"]');

    // Firefox requires this test to focus the <fieldset> first, while this is not necessary in
    // https://jsbin.com/nenirisage/edit?html,js,console,output
    element.focus();

    element.querySelector('legend').focus();
    return _document.activeElement === focusable && 'focusable' || _document.activeElement === tabbable && 'tabbable' || '';
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-scroll-body.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// https://github.com/medialize/ally.js/issues/21
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
    return element.querySelector('div');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-scroll-container-without-overflow.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// https://github.com/medialize/ally.js/issues/21
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-scroll-container.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// https://github.com/medialize/ally.js/issues/21
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('style', 'width: 100px; height: 50px; overflow: auto;');
    element.innerHTML = '<div style="width: 500px; height: 40px;">scrollable content</div>';
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-summary.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'details',
  mutate: function mutate(element) {
    element.innerHTML = '<summary>foo</summary><p>content</p>';
    return element.firstElementChild;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-focusable-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<text focusable="true">a</text>');
    return element.querySelector('text');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-foreignobject-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<foreignObject tabindex="-1"><input type="text" /></foreignObject>');
    // Safari 8's quersSelector() can't identify foreignObject, but getElementyByTagName() can
    return element.querySelector('foreignObject') || element.getElementsByTagName('foreignObject')[0];
  },
  validate: _svg.validate

};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-in-iframe.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Firefox seems to be handling the SVG-document-in-iframe creation asynchronously
// and thereby produces a false negative test result. Thus the test is pointless
// and we resort to UA sniffing once again.
// see http://jsbin.com/vunadohoko/1/edit?js,console,output

var result = Boolean(_platform2.default.is.GECKO && typeof SVGElement !== 'undefined' && SVGElement.prototype.focus);

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-negative-tabindex-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<text tabindex="-1">a</text>');
    return element.querySelector('text');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-tabindex-attribute.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('<text tabindex="0">a</text>');
    return element.querySelector('text');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-use-tabindex.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)(['<g id="ally-test-target"><a xlink:href="#void"><text>link</text></a></g>', '<use xlink:href="#ally-test-target" x="0" y="0" tabindex="-1" />'].join(''));

    return element.querySelector('use');
  },
  validate: _svg.validate
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _svg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js");

exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.innerHTML = (0, _svg.generate)('');
    return element.firstChild;
  },
  validate: _svg.validate
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-tabindex-trailing-characters.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// Firefox allows *any* value and treats invalid values like tabindex="-1"
// @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
exports.default = {
  element: 'div',
  mutate: function mutate(element) {
    element.setAttribute('tabindex', '3x');
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-table.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  element: 'table',
  mutate: function mutate(element, wrapper, _document) {
    // IE9 has a problem replacing TBODY contents with innerHTML.
    // https://stackoverflow.com/a/8097055/515124
    // element.innerHTML = '<tr><td>cell</td></tr>';
    var fragment = _document.createDocumentFragment();
    fragment.innerHTML = '<tr><td>cell</td></tr>';
    element.appendChild(fragment);
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-video-without-controls.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mp = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\mp4.js");

var _mp2 = _interopRequireDefault(_mp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  element: 'video',
  mutate: function mutate(element) {
    try {
      // invalid media file can trigger warning in console, data-uri to prevent HTTP request
      element.setAttribute('src', _mp2.default);
    } catch (e) {
      // IE9 may throw "Error: Not implemented"
    }
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\helper\\svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate = generate;
exports.focus = focus;
exports.validate = validate;

var _focus = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\element\\focus.svg-foreign-object-hack.js");

var _focus2 = _interopRequireDefault(_focus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function generate(element) {
  return '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">' + element + '</svg>';
}

function focus(element) {
  if (element.focus) {
    return;
  }

  try {
    HTMLElement.prototype.focus.call(element);
  } catch (e) {
    (0, _focus2.default)(element);
  }
}

function validate(element, focusTarget, _document) {
  focus(focusTarget);
  return _document.activeElement === focusTarget;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.invalid.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZZ';

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\mp3.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gif2.default;
// export default 'data:audio/mp3;base64,audio-focus-test';

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\mp4.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _gif = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\gif.js");

var _gif2 = _interopRequireDefault(_gif);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _gif2.default;
// export default 'data:video/mp4;base64,video-focus-test';

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\media\\svg.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = 'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtb' + 'G5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBpZD0ic3ZnIj48dGV4dCB4PSIxMCIgeT0iMjAiIGlkPSJ' + 'zdmctbGluay10ZXh0Ij50ZXh0PC90ZXh0Pjwvc3ZnPg==';

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports-cache.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _version = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\version.js");

var _version2 = _interopRequireDefault(_version);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function readLocalStorage(key) {
  // allow reading from storage to retrieve previous support results
  // even while the document does not have focus
  var data = void 0;

  try {
    data = window.localStorage && window.localStorage.getItem(key);
    data = data ? JSON.parse(data) : {};
  } catch (e) {
    data = {};
  }

  return data;
} /*
      Facility to cache test results in localStorage.
  
      USAGE:
        cache.get('key');
        cache.set('key', 'value');
   */

function writeLocalStorage(key, value) {
  if (!document.hasFocus()) {
    // if the document does not have focus when tests are executed, focus() may
    // not be handled properly and events may not be dispatched immediately.
    // This can happen when a document is reloaded while Developer Tools have focus.
    try {
      window.localStorage && window.localStorage.removeItem(key);
    } catch (e) {
      // ignore
    }

    return;
  }

  try {
    window.localStorage && window.localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    // ignore
  }
}

var userAgent = typeof window !== 'undefined' && window.navigator.userAgent || '';
var cacheKey = 'ally-supports-cache';
var cache = readLocalStorage(cacheKey);

// update the cache if ally or the user agent changed (newer version, etc)
if (cache.userAgent !== userAgent || cache.version !== _version2.default) {
  cache = {};
}

cache.userAgent = userAgent;
cache.version = _version2.default;

exports.default = {
  get: function get() {
    return cache;
  },
  set: function set(values) {
    Object.keys(values).forEach(function (key) {
      cache[key] = values[key];
    });

    cache.time = new Date().toISOString();
    writeLocalStorage(cacheKey, cache);
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  if (supportsCache) {
    return supportsCache;
  }

  supportsCache = _supportsCache2.default.get();
  if (!supportsCache.time) {
    _supportsCache2.default.set(executeTests());
    supportsCache = _supportsCache2.default.get();
  }

  return supportsCache;
};

var _detectFocus = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\detect-focus.js");

var _detectFocus2 = _interopRequireDefault(_detectFocus);

var _supportsCache = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\supports-cache.js");

var _supportsCache2 = _interopRequireDefault(_supportsCache);

var _cssShadowPiercingDeepCombinator = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\css-shadow-piercing-deep-combinator.js");

var _cssShadowPiercingDeepCombinator2 = _interopRequireDefault(_cssShadowPiercingDeepCombinator);

var _focusAreaImgTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-area-img-tabindex.js");

var _focusAreaImgTabindex2 = _interopRequireDefault(_focusAreaImgTabindex);

var _focusAreaTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-area-tabindex.js");

var _focusAreaTabindex2 = _interopRequireDefault(_focusAreaTabindex);

var _focusAreaWithoutHref = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-area-without-href.js");

var _focusAreaWithoutHref2 = _interopRequireDefault(_focusAreaWithoutHref);

var _focusAudioWithoutControls = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-audio-without-controls.js");

var _focusAudioWithoutControls2 = _interopRequireDefault(_focusAudioWithoutControls);

var _focusBrokenImageMap = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-broken-image-map.js");

var _focusBrokenImageMap2 = _interopRequireDefault(_focusBrokenImageMap);

var _focusChildrenOfFocusableFlexbox = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-children-of-focusable-flexbox.js");

var _focusChildrenOfFocusableFlexbox2 = _interopRequireDefault(_focusChildrenOfFocusableFlexbox);

var _focusFieldsetDisabled = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-fieldset-disabled.js");

var _focusFieldsetDisabled2 = _interopRequireDefault(_focusFieldsetDisabled);

var _focusFieldset = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-fieldset.js");

var _focusFieldset2 = _interopRequireDefault(_focusFieldset);

var _focusFlexboxContainer = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-flexbox-container.js");

var _focusFlexboxContainer2 = _interopRequireDefault(_focusFlexboxContainer);

var _focusFormDisabled = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-form-disabled.js");

var _focusFormDisabled2 = _interopRequireDefault(_focusFormDisabled);

var _focusImgIsmap = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-img-ismap.js");

var _focusImgIsmap2 = _interopRequireDefault(_focusImgIsmap);

var _focusImgUsemapTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-img-usemap-tabindex.js");

var _focusImgUsemapTabindex2 = _interopRequireDefault(_focusImgUsemapTabindex);

var _focusInHiddenIframe = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-in-hidden-iframe.js");

var _focusInHiddenIframe2 = _interopRequireDefault(_focusInHiddenIframe);

var _focusInZeroDimensionObject = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-in-zero-dimension-object.js");

var _focusInZeroDimensionObject2 = _interopRequireDefault(_focusInZeroDimensionObject);

var _focusInvalidTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-invalid-tabindex.js");

var _focusInvalidTabindex2 = _interopRequireDefault(_focusInvalidTabindex);

var _focusLabelTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-label-tabindex.js");

var _focusLabelTabindex2 = _interopRequireDefault(_focusLabelTabindex);

var _focusObjectSvgHidden = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-object-svg-hidden.js");

var _focusObjectSvgHidden2 = _interopRequireDefault(_focusObjectSvgHidden);

var _focusObjectSvg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-object-svg.js");

var _focusObjectSvg2 = _interopRequireDefault(_focusObjectSvg);

var _focusObjectSwf = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-object-swf.js");

var _focusObjectSwf2 = _interopRequireDefault(_focusObjectSwf);

var _focusRedirectImgUsemap = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-redirect-img-usemap.js");

var _focusRedirectImgUsemap2 = _interopRequireDefault(_focusRedirectImgUsemap);

var _focusRedirectLegend = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-redirect-legend.js");

var _focusRedirectLegend2 = _interopRequireDefault(_focusRedirectLegend);

var _focusScrollBody = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-scroll-body.js");

var _focusScrollBody2 = _interopRequireDefault(_focusScrollBody);

var _focusScrollContainerWithoutOverflow = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-scroll-container-without-overflow.js");

var _focusScrollContainerWithoutOverflow2 = _interopRequireDefault(_focusScrollContainerWithoutOverflow);

var _focusScrollContainer = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-scroll-container.js");

var _focusScrollContainer2 = _interopRequireDefault(_focusScrollContainer);

var _focusSummary = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-summary.js");

var _focusSummary2 = _interopRequireDefault(_focusSummary);

var _focusSvgFocusableAttribute = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-focusable-attribute.js");

var _focusSvgFocusableAttribute2 = _interopRequireDefault(_focusSvgFocusableAttribute);

var _focusSvgTabindexAttribute = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-tabindex-attribute.js");

var _focusSvgTabindexAttribute2 = _interopRequireDefault(_focusSvgTabindexAttribute);

var _focusSvgNegativeTabindexAttribute = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-negative-tabindex-attribute.js");

var _focusSvgNegativeTabindexAttribute2 = _interopRequireDefault(_focusSvgNegativeTabindexAttribute);

var _focusSvgUseTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-use-tabindex.js");

var _focusSvgUseTabindex2 = _interopRequireDefault(_focusSvgUseTabindex);

var _focusSvgForeignobjectTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-foreignobject-tabindex.js");

var _focusSvgForeignobjectTabindex2 = _interopRequireDefault(_focusSvgForeignobjectTabindex);

var _focusSvgInIframe = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg-in-iframe.js");

var _focusSvgInIframe2 = _interopRequireDefault(_focusSvgInIframe);

var _focusSvg = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-svg.js");

var _focusSvg2 = _interopRequireDefault(_focusSvg);

var _focusTabindexTrailingCharacters = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-tabindex-trailing-characters.js");

var _focusTabindexTrailingCharacters2 = _interopRequireDefault(_focusTabindexTrailingCharacters);

var _focusTable = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-table.js");

var _focusTable2 = _interopRequireDefault(_focusTable);

var _focusVideoWithoutControls = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\focus-video-without-controls.js");

var _focusVideoWithoutControls2 = _interopRequireDefault(_focusVideoWithoutControls);

var _tabsequenceAreaAtImgPosition = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\tabsequence-area-at-img-position.js");

var _tabsequenceAreaAtImgPosition2 = _interopRequireDefault(_tabsequenceAreaAtImgPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var testCallbacks = {
  cssShadowPiercingDeepCombinator: _cssShadowPiercingDeepCombinator2.default,
  focusInZeroDimensionObject: _focusInZeroDimensionObject2.default,
  focusObjectSwf: _focusObjectSwf2.default,
  focusSvgInIframe: _focusSvgInIframe2.default,
  tabsequenceAreaAtImgPosition: _tabsequenceAreaAtImgPosition2.default
};

var testDescriptions = {
  focusAreaImgTabindex: _focusAreaImgTabindex2.default,
  focusAreaTabindex: _focusAreaTabindex2.default,
  focusAreaWithoutHref: _focusAreaWithoutHref2.default,
  focusAudioWithoutControls: _focusAudioWithoutControls2.default,
  focusBrokenImageMap: _focusBrokenImageMap2.default,
  focusChildrenOfFocusableFlexbox: _focusChildrenOfFocusableFlexbox2.default,
  focusFieldsetDisabled: _focusFieldsetDisabled2.default,
  focusFieldset: _focusFieldset2.default,
  focusFlexboxContainer: _focusFlexboxContainer2.default,
  focusFormDisabled: _focusFormDisabled2.default,
  focusImgIsmap: _focusImgIsmap2.default,
  focusImgUsemapTabindex: _focusImgUsemapTabindex2.default,
  focusInHiddenIframe: _focusInHiddenIframe2.default,
  focusInvalidTabindex: _focusInvalidTabindex2.default,
  focusLabelTabindex: _focusLabelTabindex2.default,
  focusObjectSvg: _focusObjectSvg2.default,
  focusObjectSvgHidden: _focusObjectSvgHidden2.default,
  focusRedirectImgUsemap: _focusRedirectImgUsemap2.default,
  focusRedirectLegend: _focusRedirectLegend2.default,
  focusScrollBody: _focusScrollBody2.default,
  focusScrollContainerWithoutOverflow: _focusScrollContainerWithoutOverflow2.default,
  focusScrollContainer: _focusScrollContainer2.default,
  focusSummary: _focusSummary2.default,
  focusSvgFocusableAttribute: _focusSvgFocusableAttribute2.default,
  focusSvgTabindexAttribute: _focusSvgTabindexAttribute2.default,
  focusSvgNegativeTabindexAttribute: _focusSvgNegativeTabindexAttribute2.default,
  focusSvgUseTabindex: _focusSvgUseTabindex2.default,
  focusSvgForeignobjectTabindex: _focusSvgForeignobjectTabindex2.default,
  focusSvg: _focusSvg2.default,
  focusTabindexTrailingCharacters: _focusTabindexTrailingCharacters2.default,
  focusTable: _focusTable2.default,
  focusVideoWithoutControls: _focusVideoWithoutControls2.default
};

function executeTests() {
  var results = (0, _detectFocus2.default)(testDescriptions);
  Object.keys(testCallbacks).forEach(function (key) {
    results[key] = testCallbacks[key]();
  });

  return results;
}

var supportsCache = null;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\tabsequence-area-at-img-position.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return result;
};

var _platform = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://jsbin.com/vafaba/3/edit?html,js,console,output
var result = _platform2.default.is.GECKO || _platform2.default.is.TRIDENT || _platform2.default.is.EDGE;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\array-find-index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;
function findIndex(array, callback) {
  // attempt to use native or polyfilled Array#findIndex first
  if (array.findIndex) {
    return array.findIndex(callback);
  }

  var length = array.length;

  // shortcut if the array is empty
  if (length === 0) {
    return -1;
  }

  // otherwise loop over array
  for (var i = 0; i < length; i++) {
    if (callback(array[i], i, array)) {
      return i;
    }
  }

  return -1;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\compare-position.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getParentComparator = getParentComparator;

// Node.compareDocumentPosition is available since IE9
// see https://developer.mozilla.org/en-US/docs/Web/API/Node.compareDocumentPosition

// callback returns true when element is contained by parent or is the parent suited for use with Array.some()
/*
  USAGE:
    var isChildOf = getParentComparator({parent: someNode});
    listOfElements.some(isChildOf)
*/

function getParentComparator() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      parent = _ref.parent,
      element = _ref.element,
      includeSelf = _ref.includeSelf;

  if (parent) {
    return function isChildOf(node) {
      return Boolean(includeSelf && node === parent || parent.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY);
    };
  } else if (element) {
    return function isParentOf(node) {
      return Boolean(includeSelf && element === node || node.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_CONTAINED_BY);
    };
  }

  throw new TypeError('util/compare-position#getParentComparator required either options.parent or options.element');
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\context-to-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (_ref) {
  var context = _ref.context,
      _ref$label = _ref.label,
      label = _ref$label === undefined ? 'context-to-element' : _ref$label,
      resolveDocument = _ref.resolveDocument,
      defaultToDocument = _ref.defaultToDocument;

  var element = (0, _nodeArray2.default)(context)[0];

  if (resolveDocument && element && element.nodeType === Node.DOCUMENT_NODE) {
    element = element.documentElement;
  }

  if (!element && defaultToDocument) {
    return document.documentElement;
  }

  if (!element) {
    throw new TypeError(label + ' requires valid options.context');
  }

  if (element.nodeType !== Node.ELEMENT_NODE && element.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    throw new TypeError(label + ' requires options.context to be an Element');
  }

  return element;
};

var _nodeArray = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\decorate-service.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      engage = _ref2.engage,
      disengage = _ref2.disengage;

  var data = {
    engage: engage || noop,
    disengage: disengage || noop,
    instances: 0,
    _result: null
  };

  return initialize.bind(data);
};

/*
  The Singleton Decorator is intended to allow modules to initialize a ("singleton") component as if
  it was the only one using it. Every module gets to initialize and destruct the component by itself.
  Via simple reference counting the component keeps track of how many modules have initialized it,
  so it destructs only when the last module is gone. This decorator hides the component's singleton
  nature from the application in order to offer a homogenous API.

  engage() can return an object (result) with methods to expose to the consumer,
  upon initialization result.disengage is added and returned to the consumer.
*/

function destruct() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      force = _ref.force;

  if (force) {
    this.instances = 0;
  } else {
    this.instances--;
  }

  if (!this.instances) {
    this.disengage();
    this._result = null;
  }
}

function initialize() {
  if (this.instances) {
    this.instances++;
    return this._result;
  }

  this.instances++;
  this._result = this.engage() || {};
  this._result.disengage = destruct.bind(this);

  return this._result;
}

function noop() {}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\element-matches.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = elementMatches;

// Element.prototype.matches may be available at a different name
// https://developer.mozilla.org/en/docs/Web/API/Element/matches

var names = ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector'];
var name = null;

function findMethodName(element) {
  names.some(function (_name) {
    if (!element[_name]) {
      return false;
    }

    name = _name;
    return true;
  });
}

function elementMatches(element, selector) {
  if (!name) {
    findMethodName(element);
  }

  return element[name](selector);
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-content-document.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node) {
  try {
    // works on <object> and <iframe>
    return node.contentDocument
    // works on <object> and <iframe>
    || node.contentWindow && node.contentWindow.document
    // works on <object> and <iframe> that contain SVG
    || node.getSVGDocument && node.getSVGDocument() || null;
  } catch (e) {
    // SecurityError: Failed to read the 'contentDocument' property from 'HTMLObjectElement'
    // also IE may throw member not found exception e.g. on <object type="image/png">
    return null;
  }
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-document.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node) {
  if (!node) {
    return document;
  }

  if (node.nodeType === Node.DOCUMENT_NODE) {
    return node;
  }

  return node.ownerDocument || document;
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-frame-element.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFrameElement;

var _getContentDocument = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-content-document.js");

var _getContentDocument2 = _interopRequireDefault(_getContentDocument);

var _getWindow = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-window.js");

var _getWindow2 = _interopRequireDefault(_getWindow);

var _selectInShadows = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\select-in-shadows.js");

var _selectInShadows2 = _interopRequireDefault(_selectInShadows);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selector = void 0;

function findDocumentHostElement(_window) {
  if (!selector) {
    selector = (0, _selectInShadows2.default)('object, iframe');
  }

  if (_window._frameElement !== undefined) {
    return _window._frameElement;
  }

  _window._frameElement = null;

  var potentialHosts = _window.parent.document.querySelectorAll(selector);
  [].some.call(potentialHosts, function (element) {
    var _document = (0, _getContentDocument2.default)(element);
    if (_document !== _window.document) {
      return false;
    }

    _window._frameElement = element;
    return true;
  });

  return _window._frameElement;
}

function getFrameElement(element) {
  var _window = (0, _getWindow2.default)(element);
  if (!_window.parent || _window.parent === _window) {
    // if there is no parent browsing context,
    // we're not going to get a frameElement either way
    return null;
  }

  try {
    // see https://developer.mozilla.org/en-US/docs/Web/API/Window/frameElement
    // does not work within <embed> anywhere, and not within in <object> in IE
    return _window.frameElement || findDocumentHostElement(_window);
  } catch (e) {
    return null;
  }
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-window.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (node) {
  var _document = (0, _getDocument2.default)(node);
  return _document.defaultView || window;
};

var _getDocument = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\image-map.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMapByName = getMapByName;
exports.getMapOfImage = getMapOfImage;
exports.getImageOfArea = getImageOfArea;

var _css = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\css.escape\\css.escape.js");

var _css2 = _interopRequireDefault(_css);

var _getDocument = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\get-document.js");

var _getDocument2 = _interopRequireDefault(_getDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getMapByName(name, _document) {
  // apparently getElementsByName() also considers id attribute in IE & opera
  // https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByName
  var map = _document.querySelector('map[name="' + (0, _css2.default)(name) + '"]');
  return map || null;
}

function getMapOfImage(element) {
  var usemap = element.getAttribute('usemap');
  if (!usemap) {
    return null;
  }

  var _document = (0, _getDocument2.default)(element);
  return getMapByName(usemap.slice(1), _document);
}

function getImageOfArea(element) {
  var map = element.parentElement;

  if (!map.name || map.nodeName.toLowerCase() !== 'map') {
    return null;
  }

  // NOTE: image maps can also be applied to <object> with image content,
  // but no browser supports this at the moment

  // HTML5 specifies HTMLMapElement.images to be an HTMLCollection of all
  // <img> and <object> referencing the <map> element, but no browser implements this
  //   https://www.w3.org/TR/html5/embedded-content-0.html#the-map-element
  //   https://developer.mozilla.org/en-US/docs/Web/API/HTMLMapElement
  // the image must be valid and loaded for the map to take effect
  var _document = (0, _getDocument2.default)(element);
  return _document.querySelector('img[usemap="#' + (0, _css2.default)(map.name) + '"]') || null;
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\node-array.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (input) {
  if (!input) {
    return [];
  }

  if (Array.isArray(input)) {
    return input;
  }

  // instanceof Node - does not work with iframes
  if (input.nodeType !== undefined) {
    return [input];
  }

  if (typeof input === 'string') {
    input = document.querySelectorAll(input);
  }

  if (input.length !== undefined) {
    return [].slice.call(input, 0);
  }

  throw new TypeError('unexpected input ' + String(input));
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\platform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _platform2 = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\platform\\platform.js");

var _platform3 = _interopRequireDefault(_platform2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// deep clone of original platform
var platform = JSON.parse(JSON.stringify(_platform3.default));

// operating system

// sugar for https://github.com/bestiejs/platform.js
// make sure to ALWAYS reference the layout engine,
// even if it is not necessary for the condition,
// as this makes grepping for this stuff simpler

var os = platform.os.family || '';
var ANDROID = os === 'Android';
var WINDOWS = os.slice(0, 7) === 'Windows';
var OSX = os === 'OS X';
var IOS = os === 'iOS';

// layout
var BLINK = platform.layout === 'Blink';
var GECKO = platform.layout === 'Gecko';
var TRIDENT = platform.layout === 'Trident';
var EDGE = platform.layout === 'EdgeHTML';
var WEBKIT = platform.layout === 'WebKit';

// browser version (not layout engine version!)
var version = parseFloat(platform.version);
var majorVersion = Math.floor(version);
platform.majorVersion = majorVersion;

platform.is = {
  // operating system
  ANDROID: ANDROID,
  WINDOWS: WINDOWS,
  OSX: OSX,
  IOS: IOS,
  // layout
  BLINK: BLINK, // "Chrome", "Chrome Mobile", "Opera"
  GECKO: GECKO, // "Firefox"
  TRIDENT: TRIDENT, // "Internet Explorer"
  EDGE: EDGE, // "Microsoft Edge"
  WEBKIT: WEBKIT, // "Safari"
  // INTERNET EXPLORERS
  IE9: TRIDENT && majorVersion === 9,
  IE10: TRIDENT && majorVersion === 10,
  IE11: TRIDENT && majorVersion === 11
};

exports.default = platform;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\select-in-shadows.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (selector) {
  if (typeof shadowPrefix !== 'string') {
    var operator = (0, _cssShadowPiercingDeepCombinator2.default)();
    if (operator) {
      shadowPrefix = ', html ' + operator + ' ';
    }
  }

  if (!shadowPrefix) {
    return selector;
  }

  return selector + shadowPrefix + selector.replace(/\s*,\s*/g, ',').split(',').join(shadowPrefix);
};

var _cssShadowPiercingDeepCombinator = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\supports\\css-shadow-piercing-deep-combinator.js");

var _cssShadowPiercingDeepCombinator2 = _interopRequireDefault(_cssShadowPiercingDeepCombinator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var shadowPrefix = void 0;
// convert a CSS selector so that it also pierces ShadowDOM
// takes ".a, #b" and turns it into ".a, #b, html >>> .a, html >>> #b"

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\tabindex-value.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (element) {
  if (!(0, _validTabindex2.default)(element)) {
    return null;
  }

  // Edge 14 has a capitalization problem on SVG elements,
  // see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/9282058/
  var hasTabindex = element.hasAttribute('tabindex');
  var attributeName = hasTabindex ? 'tabindex' : 'tabIndex';

  // @browser-issue Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
  var tabindex = parseInt(element.getAttribute(attributeName), 10);
  return isNaN(tabindex) ? -1 : tabindex;
};

var _validTabindex = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\is\\valid-tabindex.js");

var _validTabindex2 = _interopRequireDefault(_validTabindex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\toggle-class.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleClass = toggleClass;
exports.removeClass = removeClass;
exports.addClass = addClass;
//
// This util allows to easily add, remove or toggle classes.
//
// Using it is neccessary as IE 9 doesn't support element classList
// and IE 11 doesn't support classList for SVG elements
// see also https://developer.mozilla.org/en/docs/Web/API/Element/classList
//
// This file is a replacement for domtokenlist because of
// https://github.com/medialize/ally.js/issues/147
//
// Usage:
//
// toggleClass(div, 'demo'); // Toggles the class `demo`
// toggleClass(div, 'demo', true); // Adds the class `demo`
// toggleClass(div, 'demo', false); // removes the class `demo`
//
// removeClass(div, 'demo');
// addClass(div, 'demo');
//

/**
 * Extract an array of all classNames of the given DOM or SVG node
 */
function getClassNames(element) {
  var className = element.getAttribute && element.getAttribute('class') || '';
  return className === '' ? [] : className.split(' ');
}

function toggleClass(element, className, force) {
  var classNames = getClassNames(element);
  var idx = classNames.indexOf(className);
  var hasClass = idx !== -1;
  var shouldHaveClass = force !== undefined ? force : !hasClass;
  // Break if classes are already set/removed
  if (shouldHaveClass === hasClass) {
    return;
  }
  // Remove class
  if (!shouldHaveClass) {
    classNames.splice(idx, 1);
  }
  // Add class
  if (shouldHaveClass) {
    classNames.push(className);
  }
  element.setAttribute('class', classNames.join(' '));
}

function removeClass(element, className) {
  return toggleClass(element, className, false);
}

function addClass(element, className) {
  return toggleClass(element, className, true);
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\version.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

// this file is overwritten by `npm run build:pre`
var version = '1.4.1';
exports.default = version;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\when\\key.binding.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  return text.split(/\s+/).map(function (_text) {
    var tokens = _text.split('+');
    var _modifiers = resolveModifiers(tokens.slice(0, -1));
    var _keyCodes = resolveKey(tokens.slice(-1));
    return {
      keyCodes: _keyCodes,
      modifiers: _modifiers,
      matchModifiers: matchModifiers.bind(null, _modifiers)
    };
  });
};

var _keycode = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\map\\keycode.js");

var _keycode2 = _interopRequireDefault(_keycode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modifier = {
  alt: 'altKey',
  ctrl: 'ctrlKey',
  meta: 'metaKey',
  shift: 'shiftKey'
};
/*
  decodes a key binding token to a JavaScript structure

  returns an array of objects:
    {
      // key name translated to keyCode (possibly more than one)
      keyCodes: [<number>],
      // translated modifiers
      modifiers: {
        altKey: null,   // ignore
        ctrKey: false,  // expect not pressed
        metaKey: true,  // expect pressed
        shiftKey: true, // expect pressed
      },
      // callback that returns true if event's
      // modifier keys match the expected state
      matchModifiers: function(event){},
    }
*/

var modifierSequence = Object.keys(modifier).map(function (name) {
  return modifier[name];
});

function createExpectedModifiers(ignoreModifiers) {
  var value = ignoreModifiers ? null : false;
  return {
    altKey: value,
    ctrlKey: value,
    metaKey: value,
    shiftKey: value
  };
}

function resolveModifiers(modifiers) {
  var ignoreModifiers = modifiers.indexOf('*') !== -1;
  var expected = createExpectedModifiers(ignoreModifiers);

  modifiers.forEach(function (token) {
    if (token === '*') {
      // we've already covered the all-in operator
      return;
    }

    // we want the modifier pressed
    var value = true;
    var operator = token.slice(0, 1);
    if (operator === '?') {
      // we don't care if the modifier is pressed
      value = null;
    } else if (operator === '!') {
      // we do not want the modifier pressed
      value = false;
    }

    if (value !== true) {
      // compensate for the modifier's operator
      token = token.slice(1);
    }

    var propertyName = modifier[token];
    if (!propertyName) {
      throw new TypeError('Unknown modifier "' + token + '"');
    }

    expected[propertyName] = value;
  });

  return expected;
}

function resolveKey(key) {
  var code = _keycode2.default[key] || parseInt(key, 10);
  if (!code || typeof code !== 'number' || isNaN(code)) {
    throw new TypeError('Unknown key "' + key + '"');
  }

  return [code].concat(_keycode2.default._alias[code] || []);
}

function matchModifiers(expected, event) {
  // returns true on match
  return !modifierSequence.some(function (prop) {
    // returns true on mismatch
    return typeof expected[prop] === 'boolean' && Boolean(event[prop]) !== expected[prop];
  });
}

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\when\\key.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var map = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var bindings = {};

  var context = (0, _nodeArray2.default)(map.context)[0] || document.documentElement;
  delete map.context;
  var filter = (0, _nodeArray2.default)(map.filter);
  delete map.filter;

  var mapKeys = Object.keys(map);
  if (!mapKeys.length) {
    throw new TypeError('when/key requires at least one option key');
  }

  var registerBinding = function registerBinding(event) {
    event.keyCodes.forEach(function (code) {
      if (!bindings[code]) {
        bindings[code] = [];
      }

      bindings[code].push(event);
    });
  };

  mapKeys.forEach(function (text) {
    if (typeof map[text] !== 'function') {
      throw new TypeError('when/key requires option["' + text + '"] to be a function');
    }

    var addCallback = function addCallback(event) {
      event.callback = map[text];
      return event;
    };

    (0, _key2.default)(text).map(addCallback).forEach(registerBinding);
  });

  var handleKeyDown = function handleKeyDown(event) {
    if (event.defaultPrevented) {
      return;
    }

    if (filter.length) {
      // ignore elements within the exempted sub-trees
      var isParentOfElement = (0, _comparePosition.getParentComparator)({ element: event.target, includeSelf: true });
      if (filter.some(isParentOfElement)) {
        return;
      }
    }

    var key = event.keyCode || event.which;
    if (!bindings[key]) {
      return;
    }

    bindings[key].forEach(function (_event) {
      if (!_event.matchModifiers(event)) {
        return;
      }

      _event.callback.call(context, event, disengage);
    });
  };

  context.addEventListener('keydown', handleKeyDown, false);

  var disengage = function disengage() {
    context.removeEventListener('keydown', handleKeyDown, false);
  };

  return { disengage: disengage };
};

var _key = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\when\\key.binding.js");

var _key2 = _interopRequireDefault(_key);

var _nodeArray = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\node-array.js");

var _nodeArray2 = _interopRequireDefault(_nodeArray);

var _comparePosition = __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\ally.js\\src\\util\\compare-position.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\css.escape\\css.escape.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/cssescape v1.5.1 by @mathias | MIT license */
;(function (root, factory) {
	// https://github.com/umdjs/umd/blob/master/returnExports.js
	if (( false ? 'undefined' : _typeof(exports)) == 'object') {
		// For Node.js.
		module.exports = factory(root);
	} else if (true) {
		// For AMD. Register as an anonymous module.
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory.bind(root, root)),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		// For browser globals (not exposing the function separately).
		factory(root);
	}
})(typeof global != 'undefined' ? global : undefined, function (root) {

	if (root.CSS && root.CSS.escape) {
		return root.CSS.escape;
	}

	// https://drafts.csswg.org/cssom/#serialize-an-identifier
	var cssEscape = function cssEscape(value) {
		if (arguments.length == 0) {
			throw new TypeError('`CSS.escape` requires an argument.');
		}
		var string = String(value);
		var length = string.length;
		var index = -1;
		var codeUnit;
		var result = '';
		var firstCodeUnit = string.charCodeAt(0);
		while (++index < length) {
			codeUnit = string.charCodeAt(index);
			// Note: there’s no need to special-case astral symbols, surrogate
			// pairs, or lone surrogates.

			// If the character is NULL (U+0000), then the REPLACEMENT CHARACTER
			// (U+FFFD).
			if (codeUnit == 0x0000) {
				result += '\uFFFD';
				continue;
			}

			if (
			// If the character is in the range [\1-\1F] (U+0001 to U+001F) or is
			// U+007F, […]
			codeUnit >= 0x0001 && codeUnit <= 0x001F || codeUnit == 0x007F ||
			// If the character is the first character and is in the range [0-9]
			// (U+0030 to U+0039), […]
			index == 0 && codeUnit >= 0x0030 && codeUnit <= 0x0039 ||
			// If the character is the second character and is in the range [0-9]
			// (U+0030 to U+0039) and the first character is a `-` (U+002D), […]
			index == 1 && codeUnit >= 0x0030 && codeUnit <= 0x0039 && firstCodeUnit == 0x002D) {
				// https://drafts.csswg.org/cssom/#escape-a-character-as-code-point
				result += '\\' + codeUnit.toString(16) + ' ';
				continue;
			}

			if (
			// If the character is the first character and is a `-` (U+002D), and
			// there is no second character, […]
			index == 0 && length == 1 && codeUnit == 0x002D) {
				result += '\\' + string.charAt(index);
				continue;
			}

			// If the character is not handled by one of the above rules and is
			// greater than or equal to U+0080, is `-` (U+002D) or `_` (U+005F), or
			// is in one of the ranges [0-9] (U+0030 to U+0039), [A-Z] (U+0041 to
			// U+005A), or [a-z] (U+0061 to U+007A), […]
			if (codeUnit >= 0x0080 || codeUnit == 0x002D || codeUnit == 0x005F || codeUnit >= 0x0030 && codeUnit <= 0x0039 || codeUnit >= 0x0041 && codeUnit <= 0x005A || codeUnit >= 0x0061 && codeUnit <= 0x007A) {
				// the character itself
				result += string.charAt(index);
				continue;
			}

			// Otherwise, the escaped character.
			// https://drafts.csswg.org/cssom/#escape-a-character
			result += '\\' + string.charAt(index);
		}
		return result;
	};

	if (!root.CSS) {
		root.CSS = {};
	}

	root.CSS.escape = cssEscape;
	return cssEscape;
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js")))

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\platform\\platform.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!
 * Platform.js <https://mths.be/platform>
 * Copyright 2014-2016 Benjamin Tan <https://demoneaux.github.io/>
 * Copyright 2011-2013 John-David Dalton <http://allyoucanleet.com/>
 * Available under MIT license <https://mths.be/mit>
 */
;(function () {
  'use strict';

  /** Used to determine if values are of the language type `Object`. */

  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used as a reference to the global object. */
  var root = objectTypes[typeof window === 'undefined' ? 'undefined' : _typeof(window)] && window || this;

  /** Backup possible global object. */
  var oldRoot = root;

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[ false ? 'undefined' : _typeof(exports)] && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[ false ? 'undefined' : _typeof(module)] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js or Browserified code and use it as `root`. */
  var freeGlobal = freeExports && freeModule && (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  /**
   * Used as the maximum length of an array-like object.
   * See the [ES6 spec](http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength)
   * for more details.
   */
  var maxSafeInteger = Math.pow(2, 53) - 1;

  /** Regular expression to detect Opera. */
  var reOpera = /\bOpera/;

  /** Possible global object. */
  var thisBinding = this;

  /** Used for native method references. */
  var objectProto = Object.prototype;

  /** Used to check for own properties of an object. */
  var hasOwnProperty = objectProto.hasOwnProperty;

  /** Used to resolve the internal `[[Class]]` of values. */
  var toString = objectProto.toString;

  /*--------------------------------------------------------------------------*/

  /**
   * Capitalizes a string value.
   *
   * @private
   * @param {string} string The string to capitalize.
   * @returns {string} The capitalized string.
   */
  function capitalize(string) {
    string = String(string);
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * A utility function to clean up the OS name.
   *
   * @private
   * @param {string} os The OS name to clean up.
   * @param {string} [pattern] A `RegExp` pattern matching the OS name.
   * @param {string} [label] A label for the OS.
   */
  function cleanupOS(os, pattern, label) {
    // Platform tokens are defined at:
    // http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    // http://web.archive.org/web/20081122053950/http://msdn.microsoft.com/en-us/library/ms537503(VS.85).aspx
    var data = {
      '10.0': '10',
      '6.4': '10 Technical Preview',
      '6.3': '8.1',
      '6.2': '8',
      '6.1': 'Server 2008 R2 / 7',
      '6.0': 'Server 2008 / Vista',
      '5.2': 'Server 2003 / XP 64-bit',
      '5.1': 'XP',
      '5.01': '2000 SP1',
      '5.0': '2000',
      '4.0': 'NT',
      '4.90': 'ME'
    };
    // Detect Windows version from platform tokens.
    if (pattern && label && /^Win/i.test(os) && !/^Windows Phone /i.test(os) && (data = data[/[\d.]+$/.exec(os)])) {
      os = 'Windows ' + data;
    }
    // Correct character case and cleanup string.
    os = String(os);

    if (pattern && label) {
      os = os.replace(RegExp(pattern, 'i'), label);
    }

    os = format(os.replace(/ ce$/i, ' CE').replace(/\bhpw/i, 'web').replace(/\bMacintosh\b/, 'Mac OS').replace(/_PowerPC\b/i, ' OS').replace(/\b(OS X) [^ \d]+/i, '$1').replace(/\bMac (OS X)\b/, '$1').replace(/\/(\d)/, ' $1').replace(/_/g, '.').replace(/(?: BePC|[ .]*fc[ \d.]+)$/i, '').replace(/\bx86\.64\b/gi, 'x86_64').replace(/\b(Windows Phone) OS\b/, '$1').replace(/\b(Chrome OS \w+) [\d.]+\b/, '$1').split(' on ')[0]);

    return os;
  }

  /**
   * An iteration utility for arrays and objects.
   *
   * @private
   * @param {Array|Object} object The object to iterate over.
   * @param {Function} callback The function called per iteration.
   */
  function each(object, callback) {
    var index = -1,
        length = object ? object.length : 0;

    if (typeof length == 'number' && length > -1 && length <= maxSafeInteger) {
      while (++index < length) {
        callback(object[index], index, object);
      }
    } else {
      forOwn(object, callback);
    }
  }

  /**
   * Trim and conditionally capitalize string values.
   *
   * @private
   * @param {string} string The string to format.
   * @returns {string} The formatted string.
   */
  function format(string) {
    string = trim(string);
    return (/^(?:webOS|i(?:OS|P))/.test(string) ? string : capitalize(string)
    );
  }

  /**
   * Iterates over an object's own properties, executing the `callback` for each.
   *
   * @private
   * @param {Object} object The object to iterate over.
   * @param {Function} callback The function executed per own property.
   */
  function forOwn(object, callback) {
    for (var key in object) {
      if (hasOwnProperty.call(object, key)) {
        callback(object[key], key, object);
      }
    }
  }

  /**
   * Gets the internal `[[Class]]` of a value.
   *
   * @private
   * @param {*} value The value.
   * @returns {string} The `[[Class]]`.
   */
  function getClassOf(value) {
    return value == null ? capitalize(value) : toString.call(value).slice(8, -1);
  }

  /**
   * Host objects can return type values that are different from their actual
   * data type. The objects we are concerned with usually return non-primitive
   * types of "object", "function", or "unknown".
   *
   * @private
   * @param {*} object The owner of the property.
   * @param {string} property The property to check.
   * @returns {boolean} Returns `true` if the property value is a non-primitive, else `false`.
   */
  function isHostType(object, property) {
    var type = object != null ? _typeof(object[property]) : 'number';
    return !/^(?:boolean|number|string|undefined)$/.test(type) && (type == 'object' ? !!object[property] : true);
  }

  /**
   * Prepares a string for use in a `RegExp` by making hyphens and spaces optional.
   *
   * @private
   * @param {string} string The string to qualify.
   * @returns {string} The qualified string.
   */
  function qualify(string) {
    return String(string).replace(/([ -])(?!$)/g, '$1?');
  }

  /**
   * A bare-bones `Array#reduce` like utility function.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} callback The function called per iteration.
   * @returns {*} The accumulated result.
   */
  function reduce(array, callback) {
    var accumulator = null;
    each(array, function (value, index) {
      accumulator = callback(accumulator, value, index, array);
    });
    return accumulator;
  }

  /**
   * Removes leading and trailing whitespace from a string.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} The trimmed string.
   */
  function trim(string) {
    return String(string).replace(/^ +| +$/g, '');
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Creates a new platform object.
   *
   * @memberOf platform
   * @param {Object|string} [ua=navigator.userAgent] The user agent string or
   *  context object.
   * @returns {Object} A platform object.
   */
  function parse(ua) {

    /** The environment context object. */
    var context = root;

    /** Used to flag when a custom context is provided. */
    var isCustomContext = ua && (typeof ua === 'undefined' ? 'undefined' : _typeof(ua)) == 'object' && getClassOf(ua) != 'String';

    // Juggle arguments.
    if (isCustomContext) {
      context = ua;
      ua = null;
    }

    /** Browser navigator object. */
    var nav = context.navigator || {};

    /** Browser user agent string. */
    var userAgent = nav.userAgent || '';

    ua || (ua = userAgent);

    /** Used to flag when `thisBinding` is the [ModuleScope]. */
    var isModuleScope = isCustomContext || thisBinding == oldRoot;

    /** Used to detect if browser is like Chrome. */
    var likeChrome = isCustomContext ? !!nav.likeChrome : /\bChrome\b/.test(ua) && !/internal|\n/i.test(toString.toString());

    /** Internal `[[Class]]` value shortcuts. */
    var objectClass = 'Object',
        airRuntimeClass = isCustomContext ? objectClass : 'ScriptBridgingProxyObject',
        enviroClass = isCustomContext ? objectClass : 'Environment',
        javaClass = isCustomContext && context.java ? 'JavaPackage' : getClassOf(context.java),
        phantomClass = isCustomContext ? objectClass : 'RuntimeObject';

    /** Detect Java environments. */
    var java = /\bJava/.test(javaClass) && context.java;

    /** Detect Rhino. */
    var rhino = java && getClassOf(context.environment) == enviroClass;

    /** A character to represent alpha. */
    var alpha = java ? 'a' : '\u03B1';

    /** A character to represent beta. */
    var beta = java ? 'b' : '\u03B2';

    /** Browser document object. */
    var doc = context.document || {};

    /**
     * Detect Opera browser (Presto-based).
     * http://www.howtocreate.co.uk/operaStuff/operaObject.html
     * http://dev.opera.com/articles/view/opera-mini-web-content-authoring-guidelines/#operamini
     */
    var opera = context.operamini || context.opera;

    /** Opera `[[Class]]`. */
    var operaClass = reOpera.test(operaClass = isCustomContext && opera ? opera['[[Class]]'] : getClassOf(opera)) ? operaClass : opera = null;

    /*------------------------------------------------------------------------*/

    /** Temporary variable used over the script's lifetime. */
    var data;

    /** The CPU architecture. */
    var arch = ua;

    /** Platform description array. */
    var description = [];

    /** Platform alpha/beta indicator. */
    var prerelease = null;

    /** A flag to indicate that environment features should be used to resolve the platform. */
    var useFeatures = ua == userAgent;

    /** The browser/environment version. */
    var version = useFeatures && opera && typeof opera.version == 'function' && opera.version();

    /** A flag to indicate if the OS ends with "/ Version" */
    var isSpecialCasedOS;

    /* Detectable layout engines (order is important). */
    var layout = getLayout([{ 'label': 'EdgeHTML', 'pattern': 'Edge' }, 'Trident', { 'label': 'WebKit', 'pattern': 'AppleWebKit' }, 'iCab', 'Presto', 'NetFront', 'Tasman', 'KHTML', 'Gecko']);

    /* Detectable browser names (order is important). */
    var name = getName(['Adobe AIR', 'Arora', 'Avant Browser', 'Breach', 'Camino', 'Epiphany', 'Fennec', 'Flock', 'Galeon', 'GreenBrowser', 'iCab', 'Iceweasel', 'K-Meleon', 'Konqueror', 'Lunascape', 'Maxthon', { 'label': 'Microsoft Edge', 'pattern': 'Edge' }, 'Midori', 'Nook Browser', 'PaleMoon', 'PhantomJS', 'Raven', 'Rekonq', 'RockMelt', 'SeaMonkey', { 'label': 'Silk', 'pattern': '(?:Cloud9|Silk-Accelerated)' }, 'Sleipnir', 'SlimBrowser', { 'label': 'SRWare Iron', 'pattern': 'Iron' }, 'Sunrise', 'Swiftfox', 'WebPositive', 'Opera Mini', { 'label': 'Opera Mini', 'pattern': 'OPiOS' }, 'Opera', { 'label': 'Opera', 'pattern': 'OPR' }, 'Chrome', { 'label': 'Chrome Mobile', 'pattern': '(?:CriOS|CrMo)' }, { 'label': 'Firefox', 'pattern': '(?:Firefox|Minefield)' }, { 'label': 'Firefox for iOS', 'pattern': 'FxiOS' }, { 'label': 'IE', 'pattern': 'IEMobile' }, { 'label': 'IE', 'pattern': 'MSIE' }, 'Safari']);

    /* Detectable products (order is important). */
    var product = getProduct([{ 'label': 'BlackBerry', 'pattern': 'BB10' }, 'BlackBerry', { 'label': 'Galaxy S', 'pattern': 'GT-I9000' }, { 'label': 'Galaxy S2', 'pattern': 'GT-I9100' }, { 'label': 'Galaxy S3', 'pattern': 'GT-I9300' }, { 'label': 'Galaxy S4', 'pattern': 'GT-I9500' }, 'Google TV', 'Lumia', 'iPad', 'iPod', 'iPhone', 'Kindle', { 'label': 'Kindle Fire', 'pattern': '(?:Cloud9|Silk-Accelerated)' }, 'Nexus', 'Nook', 'PlayBook', 'PlayStation 3', 'PlayStation 4', 'PlayStation Vita', 'TouchPad', 'Transformer', { 'label': 'Wii U', 'pattern': 'WiiU' }, 'Wii', 'Xbox One', { 'label': 'Xbox 360', 'pattern': 'Xbox' }, 'Xoom']);

    /* Detectable manufacturers. */
    var manufacturer = getManufacturer({
      'Apple': { 'iPad': 1, 'iPhone': 1, 'iPod': 1 },
      'Archos': {},
      'Amazon': { 'Kindle': 1, 'Kindle Fire': 1 },
      'Asus': { 'Transformer': 1 },
      'Barnes & Noble': { 'Nook': 1 },
      'BlackBerry': { 'PlayBook': 1 },
      'Google': { 'Google TV': 1, 'Nexus': 1 },
      'HP': { 'TouchPad': 1 },
      'HTC': {},
      'LG': {},
      'Microsoft': { 'Xbox': 1, 'Xbox One': 1 },
      'Motorola': { 'Xoom': 1 },
      'Nintendo': { 'Wii U': 1, 'Wii': 1 },
      'Nokia': { 'Lumia': 1 },
      'Samsung': { 'Galaxy S': 1, 'Galaxy S2': 1, 'Galaxy S3': 1, 'Galaxy S4': 1 },
      'Sony': { 'PlayStation 4': 1, 'PlayStation 3': 1, 'PlayStation Vita': 1 }
    });

    /* Detectable operating systems (order is important). */
    var os = getOS(['Windows Phone', 'Android', 'CentOS', { 'label': 'Chrome OS', 'pattern': 'CrOS' }, 'Debian', 'Fedora', 'FreeBSD', 'Gentoo', 'Haiku', 'Kubuntu', 'Linux Mint', 'OpenBSD', 'Red Hat', 'SuSE', 'Ubuntu', 'Xubuntu', 'Cygwin', 'Symbian OS', 'hpwOS', 'webOS ', 'webOS', 'Tablet OS', 'Linux', 'Mac OS X', 'Macintosh', 'Mac', 'Windows 98;', 'Windows ']);

    /*------------------------------------------------------------------------*/

    /**
     * Picks the layout engine from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected layout engine.
     */
    function getLayout(guesses) {
      return reduce(guesses, function (result, guess) {
        return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the manufacturer from an array of guesses.
     *
     * @private
     * @param {Array} guesses An object of guesses.
     * @returns {null|string} The detected manufacturer.
     */
    function getManufacturer(guesses) {
      return reduce(guesses, function (result, value, key) {
        // Lookup the manufacturer by product or scan the UA for the manufacturer.
        return result || (value[product] || value[/^[a-z]+(?: +[a-z]+\b)*/i.exec(product)] || RegExp('\\b' + qualify(key) + '(?:\\b|\\w*\\d)', 'i').exec(ua)) && key;
      });
    }

    /**
     * Picks the browser name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected browser name.
     */
    function getName(guesses) {
      return reduce(guesses, function (result, guess) {
        return result || RegExp('\\b' + (guess.pattern || qualify(guess)) + '\\b', 'i').exec(ua) && (guess.label || guess);
      });
    }

    /**
     * Picks the OS name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected OS name.
     */
    function getOS(guesses) {
      return reduce(guesses, function (result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result = RegExp('\\b' + pattern + '(?:/[\\d.]+|[ \\w.]*)', 'i').exec(ua))) {
          result = cleanupOS(result, pattern, guess.label || guess);
        }
        return result;
      });
    }

    /**
     * Picks the product name from an array of guesses.
     *
     * @private
     * @param {Array} guesses An array of guesses.
     * @returns {null|string} The detected product name.
     */
    function getProduct(guesses) {
      return reduce(guesses, function (result, guess) {
        var pattern = guess.pattern || qualify(guess);
        if (!result && (result = RegExp('\\b' + pattern + ' *\\d+[.\\w_]*', 'i').exec(ua) || RegExp('\\b' + pattern + '(?:; *(?:[a-z]+[_-])?[a-z]+\\d+|[^ ();-]*)', 'i').exec(ua))) {
          // Split by forward slash and append product version if needed.
          if ((result = String(guess.label && !RegExp(pattern, 'i').test(guess.label) ? guess.label : result).split('/'))[1] && !/[\d.]+/.test(result[0])) {
            result[0] += ' ' + result[1];
          }
          // Correct character case and cleanup string.
          guess = guess.label || guess;
          result = format(result[0].replace(RegExp(pattern, 'i'), guess).replace(RegExp('; *(?:' + guess + '[_-])?', 'i'), ' ').replace(RegExp('(' + guess + ')[-_.]?(\\w)', 'i'), '$1 $2'));
        }
        return result;
      });
    }

    /**
     * Resolves the version using an array of UA patterns.
     *
     * @private
     * @param {Array} patterns An array of UA patterns.
     * @returns {null|string} The detected version.
     */
    function getVersion(patterns) {
      return reduce(patterns, function (result, pattern) {
        return result || (RegExp(pattern + '(?:-[\\d.]+/|(?: for [\\w-]+)?[ /-])([\\d.]+[^ ();/_-]*)', 'i').exec(ua) || 0)[1] || null;
      });
    }

    /**
     * Returns `platform.description` when the platform object is coerced to a string.
     *
     * @name toString
     * @memberOf platform
     * @returns {string} Returns `platform.description` if available, else an empty string.
     */
    function toStringPlatform() {
      return this.description || '';
    }

    /*------------------------------------------------------------------------*/

    // Convert layout to an array so we can add extra details.
    layout && (layout = [layout]);

    // Detect product names that contain their manufacturer's name.
    if (manufacturer && !product) {
      product = getProduct([manufacturer]);
    }
    // Clean up Google TV.
    if (data = /\bGoogle TV\b/.exec(product)) {
      product = data[0];
    }
    // Detect simulators.
    if (/\bSimulator\b/i.test(ua)) {
      product = (product ? product + ' ' : '') + 'Simulator';
    }
    // Detect Opera Mini 8+ running in Turbo/Uncompressed mode on iOS.
    if (name == 'Opera Mini' && /\bOPiOS\b/.test(ua)) {
      description.push('running in Turbo/Uncompressed mode');
    }
    // Detect IE Mobile 11.
    if (name == 'IE' && /\blike iPhone OS\b/.test(ua)) {
      data = parse(ua.replace(/like iPhone OS/, ''));
      manufacturer = data.manufacturer;
      product = data.product;
    }
    // Detect iOS.
    else if (/^iP/.test(product)) {
        name || (name = 'Safari');
        os = 'iOS' + ((data = / OS ([\d_]+)/i.exec(ua)) ? ' ' + data[1].replace(/_/g, '.') : '');
      }
      // Detect Kubuntu.
      else if (name == 'Konqueror' && !/buntu/i.test(os)) {
          os = 'Kubuntu';
        }
        // Detect Android browsers.
        else if (manufacturer && manufacturer != 'Google' && (/Chrome/.test(name) && !/\bMobile Safari\b/i.test(ua) || /\bVita\b/.test(product)) || /\bAndroid\b/.test(os) && /^Chrome/.test(name) && /\bVersion\//i.test(ua)) {
            name = 'Android Browser';
            os = /\bAndroid\b/.test(os) ? os : 'Android';
          }
          // Detect Silk desktop/accelerated modes.
          else if (name == 'Silk') {
              if (!/\bMobi/i.test(ua)) {
                os = 'Android';
                description.unshift('desktop mode');
              }
              if (/Accelerated *= *true/i.test(ua)) {
                description.unshift('accelerated');
              }
            }
            // Detect PaleMoon identifying as Firefox.
            else if (name == 'PaleMoon' && (data = /\bFirefox\/([\d.]+)\b/.exec(ua))) {
                description.push('identifying as Firefox ' + data[1]);
              }
              // Detect Firefox OS and products running Firefox.
              else if (name == 'Firefox' && (data = /\b(Mobile|Tablet|TV)\b/i.exec(ua))) {
                  os || (os = 'Firefox OS');
                  product || (product = data[1]);
                }
                // Detect false positives for Firefox/Safari.
                else if (!name || (data = !/\bMinefield\b/i.test(ua) && /\b(?:Firefox|Safari)\b/.exec(name))) {
                    // Escape the `/` for Firefox 1.
                    if (name && !product && /[\/,]|^[^(]+?\)/.test(ua.slice(ua.indexOf(data + '/') + 8))) {
                      // Clear name of false positives.
                      name = null;
                    }
                    // Reassign a generic name.
                    if ((data = product || manufacturer || os) && (product || manufacturer || /\b(?:Android|Symbian OS|Tablet OS|webOS)\b/.test(os))) {
                      name = /[a-z]+(?: Hat)?/i.exec(/\bAndroid\b/.test(os) ? os : data) + ' Browser';
                    }
                  }
    // Detect non-Opera (Presto-based) versions (order is important).
    if (!version) {
      version = getVersion(['(?:Cloud9|CriOS|CrMo|Edge|FxiOS|IEMobile|Iron|Opera ?Mini|OPiOS|OPR|Raven|Silk(?!/[\\d.]+$))', 'Version', qualify(name), '(?:Firefox|Minefield|NetFront)']);
    }
    // Detect stubborn layout engines.
    if (data = layout == 'iCab' && parseFloat(version) > 3 && 'WebKit' || /\bOpera\b/.test(name) && (/\bOPR\b/.test(ua) ? 'Blink' : 'Presto') || /\b(?:Midori|Nook|Safari)\b/i.test(ua) && !/^(?:Trident|EdgeHTML)$/.test(layout) && 'WebKit' || !layout && /\bMSIE\b/i.test(ua) && (os == 'Mac OS' ? 'Tasman' : 'Trident') || layout == 'WebKit' && /\bPlayStation\b(?! Vita\b)/i.test(name) && 'NetFront') {
      layout = [data];
    }
    // Detect Windows Phone 7 desktop mode.
    if (name == 'IE' && (data = (/; *(?:XBLWP|ZuneWP)(\d+)/i.exec(ua) || 0)[1])) {
      name += ' Mobile';
      os = 'Windows Phone ' + (/\+$/.test(data) ? data : data + '.x');
      description.unshift('desktop mode');
    }
    // Detect Windows Phone 8.x desktop mode.
    else if (/\bWPDesktop\b/i.test(ua)) {
        name = 'IE Mobile';
        os = 'Windows Phone 8.x';
        description.unshift('desktop mode');
        version || (version = (/\brv:([\d.]+)/.exec(ua) || 0)[1]);
      }
      // Detect IE 11.
      else if (name != 'IE' && layout == 'Trident' && (data = /\brv:([\d.]+)/.exec(ua))) {
          if (name) {
            description.push('identifying as ' + name + (version ? ' ' + version : ''));
          }
          name = 'IE';
          version = data[1];
        }
    // Leverage environment features.
    if (useFeatures) {
      // Detect server-side environments.
      // Rhino has a global function while others have a global object.
      if (isHostType(context, 'global')) {
        if (java) {
          data = java.lang.System;
          arch = data.getProperty('os.arch');
          os = os || data.getProperty('os.name') + ' ' + data.getProperty('os.version');
        }
        if (isModuleScope && isHostType(context, 'system') && (data = [context.system])[0]) {
          os || (os = data[0].os || null);
          try {
            data[1] = context.require('ringo/engine').version;
            version = data[1].join('.');
            name = 'RingoJS';
          } catch (e) {
            if (data[0].global.system == context.system) {
              name = 'Narwhal';
            }
          }
        } else if (_typeof(context.process) == 'object' && !context.process.browser && (data = context.process)) {
          name = 'Node.js';
          arch = data.arch;
          os = data.platform;
          version = /[\d.]+/.exec(data.version)[0];
        } else if (rhino) {
          name = 'Rhino';
        }
      }
      // Detect Adobe AIR.
      else if (getClassOf(data = context.runtime) == airRuntimeClass) {
          name = 'Adobe AIR';
          os = data.flash.system.Capabilities.os;
        }
        // Detect PhantomJS.
        else if (getClassOf(data = context.phantom) == phantomClass) {
            name = 'PhantomJS';
            version = (data = data.version || null) && data.major + '.' + data.minor + '.' + data.patch;
          }
          // Detect IE compatibility modes.
          else if (typeof doc.documentMode == 'number' && (data = /\bTrident\/(\d+)/i.exec(ua))) {
              // We're in compatibility mode when the Trident version + 4 doesn't
              // equal the document mode.
              version = [version, doc.documentMode];
              if ((data = +data[1] + 4) != version[1]) {
                description.push('IE ' + version[1] + ' mode');
                layout && (layout[1] = '');
                version[1] = data;
              }
              version = name == 'IE' ? String(version[1].toFixed(1)) : version[0];
            }
      os = os && format(os);
    }
    // Detect prerelease phases.
    if (version && (data = /(?:[ab]|dp|pre|[ab]\d+pre)(?:\d+\+?)?$/i.exec(version) || /(?:alpha|beta)(?: ?\d)?/i.exec(ua + ';' + (useFeatures && nav.appMinorVersion)) || /\bMinefield\b/i.test(ua) && 'a')) {
      prerelease = /b/i.test(data) ? 'beta' : 'alpha';
      version = version.replace(RegExp(data + '\\+?$'), '') + (prerelease == 'beta' ? beta : alpha) + (/\d+\+?/.exec(data) || '');
    }
    // Detect Firefox Mobile.
    if (name == 'Fennec' || name == 'Firefox' && /\b(?:Android|Firefox OS)\b/.test(os)) {
      name = 'Firefox Mobile';
    }
    // Obscure Maxthon's unreliable version.
    else if (name == 'Maxthon' && version) {
        version = version.replace(/\.[\d.]+/, '.x');
      }
      // Detect Xbox 360 and Xbox One.
      else if (/\bXbox\b/i.test(product)) {
          os = null;
          if (product == 'Xbox 360' && /\bIEMobile\b/.test(ua)) {
            description.unshift('mobile mode');
          }
        }
        // Add mobile postfix.
        else if ((/^(?:Chrome|IE|Opera)$/.test(name) || name && !product && !/Browser|Mobi/.test(name)) && (os == 'Windows CE' || /Mobi/i.test(ua))) {
            name += ' Mobile';
          }
          // Detect IE platform preview.
          else if (name == 'IE' && useFeatures && context.external === null) {
              description.unshift('platform preview');
            }
            // Detect BlackBerry OS version.
            // http://docs.blackberry.com/en/developers/deliverables/18169/HTTP_headers_sent_by_BB_Browser_1234911_11.jsp
            else if ((/\bBlackBerry\b/.test(product) || /\bBB10\b/.test(ua)) && (data = (RegExp(product.replace(/ +/g, ' *') + '/([.\\d]+)', 'i').exec(ua) || 0)[1] || version)) {
                data = [data, /BB10/.test(ua)];
                os = (data[1] ? (product = null, manufacturer = 'BlackBerry') : 'Device Software') + ' ' + data[0];
                version = null;
              }
              // Detect Opera identifying/masking itself as another browser.
              // http://www.opera.com/support/kb/view/843/
              else if (this != forOwn && product != 'Wii' && (useFeatures && opera || /Opera/.test(name) && /\b(?:MSIE|Firefox)\b/i.test(ua) || name == 'Firefox' && /\bOS X (?:\d+\.){2,}/.test(os) || name == 'IE' && (os && !/^Win/.test(os) && version > 5.5 || /\bWindows XP\b/.test(os) && version > 8 || version == 8 && !/\bTrident\b/.test(ua))) && !reOpera.test(data = parse.call(forOwn, ua.replace(reOpera, '') + ';')) && data.name) {
                  // When "identifying", the UA contains both Opera and the other browser's name.
                  data = 'ing as ' + data.name + ((data = data.version) ? ' ' + data : '');
                  if (reOpera.test(name)) {
                    if (/\bIE\b/.test(data) && os == 'Mac OS') {
                      os = null;
                    }
                    data = 'identify' + data;
                  }
                  // When "masking", the UA contains only the other browser's name.
                  else {
                      data = 'mask' + data;
                      if (operaClass) {
                        name = format(operaClass.replace(/([a-z])([A-Z])/g, '$1 $2'));
                      } else {
                        name = 'Opera';
                      }
                      if (/\bIE\b/.test(data)) {
                        os = null;
                      }
                      if (!useFeatures) {
                        version = null;
                      }
                    }
                  layout = ['Presto'];
                  description.push(data);
                }
    // Detect WebKit Nightly and approximate Chrome/Safari versions.
    if (data = (/\bAppleWebKit\/([\d.]+\+?)/i.exec(ua) || 0)[1]) {
      // Correct build number for numeric comparison.
      // (e.g. "532.5" becomes "532.05")
      data = [parseFloat(data.replace(/\.(\d)$/, '.0$1')), data];
      // Nightly builds are postfixed with a "+".
      if (name == 'Safari' && data[1].slice(-1) == '+') {
        name = 'WebKit Nightly';
        prerelease = 'alpha';
        version = data[1].slice(0, -1);
      }
      // Clear incorrect browser versions.
      else if (version == data[1] || version == (data[2] = (/\bSafari\/([\d.]+\+?)/i.exec(ua) || 0)[1])) {
          version = null;
        }
      // Use the full Chrome version when available.
      data[1] = (/\bChrome\/([\d.]+)/i.exec(ua) || 0)[1];
      // Detect Blink layout engine.
      if (data[0] == 537.36 && data[2] == 537.36 && parseFloat(data[1]) >= 28 && layout == 'WebKit') {
        layout = ['Blink'];
      }
      // Detect JavaScriptCore.
      // http://stackoverflow.com/questions/6768474/how-can-i-detect-which-javascript-engine-v8-or-jsc-is-used-at-runtime-in-androi
      if (!useFeatures || !likeChrome && !data[1]) {
        layout && (layout[1] = 'like Safari');
        data = (data = data[0], data < 400 ? 1 : data < 500 ? 2 : data < 526 ? 3 : data < 533 ? 4 : data < 534 ? '4+' : data < 535 ? 5 : data < 537 ? 6 : data < 538 ? 7 : data < 601 ? 8 : '8');
      } else {
        layout && (layout[1] = 'like Chrome');
        data = data[1] || (data = data[0], data < 530 ? 1 : data < 532 ? 2 : data < 532.05 ? 3 : data < 533 ? 4 : data < 534.03 ? 5 : data < 534.07 ? 6 : data < 534.10 ? 7 : data < 534.13 ? 8 : data < 534.16 ? 9 : data < 534.24 ? 10 : data < 534.30 ? 11 : data < 535.01 ? 12 : data < 535.02 ? '13+' : data < 535.07 ? 15 : data < 535.11 ? 16 : data < 535.19 ? 17 : data < 536.05 ? 18 : data < 536.10 ? 19 : data < 537.01 ? 20 : data < 537.11 ? '21+' : data < 537.13 ? 23 : data < 537.18 ? 24 : data < 537.24 ? 25 : data < 537.36 ? 26 : layout != 'Blink' ? '27' : '28');
      }
      // Add the postfix of ".x" or "+" for approximate versions.
      layout && (layout[1] += ' ' + (data += typeof data == 'number' ? '.x' : /[.+]/.test(data) ? '' : '+'));
      // Obscure version for some Safari 1-2 releases.
      if (name == 'Safari' && (!version || parseInt(version) > 45)) {
        version = data;
      }
    }
    // Detect Opera desktop modes.
    if (name == 'Opera' && (data = /\bzbov|zvav$/.exec(os))) {
      name += ' ';
      description.unshift('desktop mode');
      if (data == 'zvav') {
        name += 'Mini';
        version = null;
      } else {
        name += 'Mobile';
      }
      os = os.replace(RegExp(' *' + data + '$'), '');
    }
    // Detect Chrome desktop mode.
    else if (name == 'Safari' && /\bChrome\b/.exec(layout && layout[1])) {
        description.unshift('desktop mode');
        name = 'Chrome Mobile';
        version = null;

        if (/\bOS X\b/.test(os)) {
          manufacturer = 'Apple';
          os = 'iOS 4.3+';
        } else {
          os = null;
        }
      }
    // Strip incorrect OS versions.
    if (version && version.indexOf(data = /[\d.]+$/.exec(os)) == 0 && ua.indexOf('/' + data + '-') > -1) {
      os = trim(os.replace(data, ''));
    }
    // Add layout engine.
    if (layout && !/\b(?:Avant|Nook)\b/.test(name) && (/Browser|Lunascape|Maxthon/.test(name) || name != 'Safari' && /^iOS/.test(os) && /\bSafari\b/.test(layout[1]) || /^(?:Adobe|Arora|Breach|Midori|Opera|Phantom|Rekonq|Rock|Sleipnir|Web)/.test(name) && layout[1])) {
      // Don't add layout details to description if they are falsey.
      (data = layout[layout.length - 1]) && description.push(data);
    }
    // Combine contextual information.
    if (description.length) {
      description = ['(' + description.join('; ') + ')'];
    }
    // Append manufacturer to description.
    if (manufacturer && product && product.indexOf(manufacturer) < 0) {
      description.push('on ' + manufacturer);
    }
    // Append product to description.
    if (product) {
      description.push((/^on /.test(description[description.length - 1]) ? '' : 'on ') + product);
    }
    // Parse the OS into an object.
    if (os) {
      data = / ([\d.+]+)$/.exec(os);
      isSpecialCasedOS = data && os.charAt(os.length - data[0].length - 1) == '/';
      os = {
        'architecture': 32,
        'family': data && !isSpecialCasedOS ? os.replace(data[0], '') : os,
        'version': data ? data[1] : null,
        'toString': function toString() {
          var version = this.version;
          return this.family + (version && !isSpecialCasedOS ? ' ' + version : '') + (this.architecture == 64 ? ' 64-bit' : '');
        }
      };
    }
    // Add browser/OS architecture.
    if ((data = /\b(?:AMD|IA|Win|WOW|x86_|x)64\b/i.exec(arch)) && !/\bi686\b/i.test(arch)) {
      if (os) {
        os.architecture = 64;
        os.family = os.family.replace(RegExp(' *' + data), '');
      }
      if (name && (/\bWOW64\b/i.test(ua) || useFeatures && /\w(?:86|32)$/.test(nav.cpuClass || nav.platform) && !/\bWin64; x64\b/i.test(ua))) {
        description.unshift('32-bit');
      }
    }
    // Chrome 39 and above on OS X is always 64-bit.
    else if (os && /^OS X/.test(os.family) && name == 'Chrome' && parseFloat(version) >= 39) {
        os.architecture = 64;
      }

    ua || (ua = null);

    /*------------------------------------------------------------------------*/

    /**
     * The platform object.
     *
     * @name platform
     * @type Object
     */
    var platform = {};

    /**
     * The platform description.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.description = ua;

    /**
     * The name of the browser's layout engine.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.layout = layout && layout[0];

    /**
     * The name of the product's manufacturer.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.manufacturer = manufacturer;

    /**
     * The name of the browser/environment.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.name = name;

    /**
     * The alpha/beta release indicator.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.prerelease = prerelease;

    /**
     * The name of the product hosting the browser.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.product = product;

    /**
     * The browser's user agent string.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.ua = ua;

    /**
     * The browser/environment version.
     *
     * @memberOf platform
     * @type string|null
     */
    platform.version = name && version;

    /**
     * The name of the operating system.
     *
     * @memberOf platform
     * @type Object
     */
    platform.os = os || {

      /**
       * The CPU architecture the OS is built for.
       *
       * @memberOf platform.os
       * @type number|null
       */
      'architecture': null,

      /**
       * The family of the OS.
       *
       * Common values include:
       * "Windows", "Windows Server 2008 R2 / 7", "Windows Server 2008 / Vista",
       * "Windows XP", "OS X", "Ubuntu", "Debian", "Fedora", "Red Hat", "SuSE",
       * "Android", "iOS" and "Windows Phone"
       *
       * @memberOf platform.os
       * @type string|null
       */
      'family': null,

      /**
       * The version of the OS.
       *
       * @memberOf platform.os
       * @type string|null
       */
      'version': null,

      /**
       * Returns the OS string.
       *
       * @memberOf platform.os
       * @returns {string} The OS string.
       */
      'toString': function toString() {
        return 'null';
      }
    };

    platform.parse = parse;
    platform.toString = toStringPlatform;

    if (platform.version) {
      description.unshift(version);
    }
    if (platform.name) {
      description.unshift(name);
    }
    if (os && name && !(os == String(os).split(' ')[0] && (os == name.split(' ')[0] || product))) {
      description.push(product ? '(' + os + ')' : 'on ' + os);
    }
    if (description.length) {
      platform.description = description.join(' ');
    }
    return platform;
  }

  /*--------------------------------------------------------------------------*/

  // Export platform.
  var platform = parse();

  // Some AMD build optimizers, like r.js, check for condition patterns like the following:
  if ("function" == 'function' && _typeof(__webpack_require__("D:\\a\\1\\s\\node_modules\\webpack\\buildin\\amd-options.js")) == 'object' && __webpack_require__("D:\\a\\1\\s\\node_modules\\webpack\\buildin\\amd-options.js")) {
    // Expose platform on the global object to prevent errors when platform is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    root.platform = platform;

    // Define as an anonymous module so platform can be aliased through path mapping.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return platform;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
      // Export for CommonJS support.
      forOwn(platform, function (value, key) {
        freeExports[key] = value;
      });
    } else {
      // Export to the global object.
      root.platform = platform;
    }
}).call(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\module.js")(module), __webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js")))

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\global.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\node_modules\\webpack\\buildin\\module.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\extract-text-webpack-plugin\\dist\\loader.js??ref--15-0!D:\\a\\1\\s\\node_modules\\css-loader\\index.js??ref--15-1!D:\\a\\1\\s\\node_modules\\postcss-loader\\lib\\index.js??ref--15-2!D:\\a\\1\\s\\css\\site__evo.css":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\file-loader\\dist\\cjs.js??ref--5-0!D:\\a\\1\\s\\node_modules\\extract-loader\\lib\\extractLoader.js!D:\\a\\1\\s\\node_modules\\html-loader\\index.js??ref--5-2!D:\\a\\1\\s\\client\\src\\site__evo\\favicons\\html_code.html":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicons__evo/favicons.webpackcruft";

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\360-image-icon-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "360-image-icon-large-usage",
      viewBox: "0 0 59 38",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#360-image-icon-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\MSDS.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "MSDS-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#MSDS-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\PDF-big.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "PDF-big-usage",
      viewBox: "0 0 40 40",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#PDF-big-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-created.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "account-created-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#account-created-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-dashboard.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "account-dashboard-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#account-dashboard-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-statement-medium.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "account-statement-medium-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#account-statement-medium-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-statement-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "account-statement-small-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#account-statement-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\account-statements.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "account-statements-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#account-statements-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\add-card.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "add-card-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#add-card-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\added-to-cart.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "added-to-cart-usage",
      viewBox: "0 0 21 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#added-to-cart-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\address.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "address-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#address-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\afterpay-available-bw.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "afterpay-available-bw-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#afterpay-available-bw-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\afterpay-available.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "afterpay-available-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#afterpay-available-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\alert-notification-on-homepage.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "alert-notification-on-homepage-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#alert-notification-on-homepage-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\alert-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "alert-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#alert-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\alert.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "alert-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#alert-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\arrow-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "arrow-up-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#arrow-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\back-in-stock-alerts.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "back-in-stock-alerts-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#back-in-stock-alerts-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\bag.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "bag-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#bag-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\become-a-stockist-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "become-a-stockist-small-usage",
      viewBox: "0 0 35 35",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#become-a-stockist-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\become-a-stockist.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "become-a-stockist-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#become-a-stockist-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\box.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "box-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#box-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\boxes.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "boxes-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#boxes-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\business-profile.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "business-profile-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#business-profile-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\business.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "business-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#business-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\calendar.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "calendar-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#calendar-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\cancelled.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "cancelled-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#cancelled-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-add-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-add-small-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-add-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-add.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-add-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-add-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-default-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-default-small-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-default-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-default.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-default-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-default-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-remove-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-remove-small-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-remove-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card-remove.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-remove-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-remove-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\card.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "card-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#card-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\cart-empty.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "cart-empty-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#cart-empty-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\cart.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "cart-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#cart-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\chart.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "chart-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#chart-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\clock.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "clock-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#clock-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\close-tiny.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "close-tiny-usage",
      viewBox: "0 0 6 7",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#close-tiny-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\close-xsmall.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "close-xsmall-usage",
      viewBox: "0 0 17 16",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#close-xsmall-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\close.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "close-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#close-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\collapse-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "collapse-large-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#collapse-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\collapse.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "collapse-usage",
      viewBox: "0 0 14 12",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#collapse-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\communication-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "communication-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#communication-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\communication.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "communication-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#communication-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\confirmed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "confirmed-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#confirmed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\contacts-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "contacts-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#contacts-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\contacts.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "contacts-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#contacts-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\currency-au.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "currency-au-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#currency-au-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\currency.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "currency-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#currency-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dashboard-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "dashboard-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#dashboard-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dashboard.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "dashboard-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#dashboard-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\date.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "date-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#date-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\deal-book.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "deal-book-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#deal-book-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\diamond.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "diamond-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#diamond-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\document.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "document-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#document-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dropdown-indicator-down.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "dropdown-indicator-down-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#dropdown-indicator-down-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\dropdown-indicator-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "dropdown-indicator-up-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#dropdown-indicator-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\email-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "email-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#email-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\email.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "email-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#email-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\error.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "error-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#error-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\expand-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "expand-large-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#expand-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\expand-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "expand-small-usage",
      viewBox: "0 0 14 12",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#expand-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\external-site-link.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "external-site-link-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#external-site-link-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\external-site.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "external-site-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#external-site-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\facebook-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "facebook-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#facebook-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\faster-checkout.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "faster-checkout-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#faster-checkout-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\file.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "file-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#file-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\free-shipping-bw.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "free-shipping-bw-usage",
      viewBox: "0 0 164 107",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#free-shipping-bw-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\general.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "general-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#general-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\green-success.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "green-success-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#green-success-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\green.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "green-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#green-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\hamburger-nav.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "hamburger-nav-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#hamburger-nav-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\handshake.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "handshake-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#handshake-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\help-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "help-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#help-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\help.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "help-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#help-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\history.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "history-usage",
      viewBox: "0 0 29 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#history-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\important.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "important-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#important-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\info-ui.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "info-ui-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#info-ui-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\info.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "info-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#info-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\instagram-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "instagram-small-usage",
      viewBox: "0 0 33 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#instagram-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\instagram-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "instagram-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#instagram-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\instructor.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "instructor-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#instructor-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\internet-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "internet-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#internet-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\invoice.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "invoice-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#invoice-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\large-chevron-down.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "large-chevron-down-usage",
      viewBox: "0 0 14 12",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#large-chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\large-chevron-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "large-chevron-up-usage",
      viewBox: "0 0 14 12",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#large-chevron-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\lightbulb.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "lightbulb-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#lightbulb-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\link-arrow-left.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "link-arrow-left-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#link-arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\link-arrow-right-large.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "link-arrow-right-large-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#link-arrow-right-large-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\link-arrow-right.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "link-arrow-right-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#link-arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\linkedin-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "linkedin-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#linkedin-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location-pin-medium.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "location-pin-medium-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#location-pin-medium-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location-pin-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "location-pin-small-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#location-pin-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "location-small-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#location-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\location.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "location-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#location-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\logout.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "logout-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#logout-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\make-default.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "make-default-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#make-default-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\manage-addresses.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "manage-addresses-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#manage-addresses-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\my-account-sign-in.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "my-account-sign-in-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#my-account-sign-in-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\my-orders.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "my-orders-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#my-orders-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\new-window.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "new-window-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#new-window-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\newsletters.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "newsletters-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#newsletters-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\no-orders-in-this-account.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "no-orders-in-this-account-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#no-orders-in-this-account-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-clock.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-clock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-clock-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-error.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-error-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-error-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-important.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-important-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-important-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-info.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-info-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-info-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-outofstock.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-outofstock-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-outofstock-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-stop.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-stop-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-stop-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification-success.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-success-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-success-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notification.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notification-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notification-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\notify-me-pop-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "notify-me-pop-up-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#notify-me-pop-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orange-high-importance.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "orange-high-importance-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#orange-high-importance-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-alt.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "order-alt-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#order-alt-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-status-cancelled.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "order-status-cancelled-usage",
      viewBox: "0 0 21 21",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#order-status-cancelled-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-status-confirmed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "order-status-confirmed-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#order-status-confirmed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-status-shipped.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "order-status-shipped-usage",
      viewBox: "0 0 20 21",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#order-status-shipped-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\order-summary.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "order-summary-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#order-summary-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orders-empty.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "orders-empty-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#orders-empty-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orders-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "orders-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#orders-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\orders.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "orders-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#orders-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\out-of-stock-nothing-in-cart.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "out-of-stock-nothing-in-cart-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#out-of-stock-nothing-in-cart-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\page.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "page-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#page-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-first-arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pagination-first-arrow-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pagination-first-arrow-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-last-arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pagination-last-arrow-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pagination-last-arrow-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-next-arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pagination-next-arrow-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pagination-next-arrow-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pagination-prev-arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pagination-prev-arrow-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pagination-prev-arrow-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\payment-method.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "payment-method-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#payment-method-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\payment-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "payment-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#payment-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\payments.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "payments-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#payments-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pdf-attachment.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pdf-attachment-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pdf-attachment-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pdf.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pdf-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\person.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "person-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#person-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\personal-details-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "personal-details-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#personal-details-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\personal-details.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "personal-details-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#personal-details-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\peta-accredited-bw.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "peta-accredited-bw-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#peta-accredited-bw-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\phone.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "phone-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\pin.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "pin-usage",
      viewBox: "0 0 16 19",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#pin-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\placeholder.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "placeholder-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#placeholder-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\play-button.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "play-button-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#play-button-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\price-tag-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "price-tag-small-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#price-tag-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\price-tag.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "price-tag-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#price-tag-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\print.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "print-usage",
      viewBox: "0 0 29 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#print-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\professional-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "professional-small-usage",
      viewBox: "0 0 25 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#professional-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\promotions-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "promotions-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#promotions-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\promotions.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "promotions-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#promotions-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\purple-standard.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "purple-standard-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#purple-standard-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\red-error.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "red-error-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#red-error-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\redo.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "redo-usage",
      viewBox: "0 0 15 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#redo-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\refund.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "refund-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#refund-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\remove-cart-delete.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "remove-cart-delete-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#remove-cart-delete-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\remove.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "remove-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#remove-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\reorder-all.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "reorder-all-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#reorder-all-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\returns-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "returns-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#returns-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\returns.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "returns-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#returns-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\salon-support.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "salon-support-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#salon-support-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-about-us.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-about-us-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-about-us-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-brochures.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-brochures-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-brochures-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-colour-chart.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-colour-chart-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-colour-chart-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-education.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-education-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-education-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-error.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-error-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-error-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-guides.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-guides-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-guides-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-help-center.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-help-center-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-help-center-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-loading.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-loading-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-loading-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-manuals.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-manuals-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-manuals-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-noresult.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-noresult-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-noresult-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search-services.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-services-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-services-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\search.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "search-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\shipped.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "shipped-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#shipped-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\shipping.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "shipping-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#shipping-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\slider-arrow-left.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "slider-arrow-left-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#slider-arrow-left-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\slider-arrow-right.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "slider-arrow-right-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#slider-arrow-right-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\small-chevron-down.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "small-chevron-down-usage",
      viewBox: "0 0 8 8",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#small-chevron-down-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\small-chevron-right.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "small-chevron-right-usage",
      viewBox: "0 0 8 8",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#small-chevron-right-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\small-chevron-up.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "small-chevron-up-usage",
      viewBox: "0 0 8 8",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#small-chevron-up-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\speech-bubble.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "speech-bubble-usage",
      viewBox: "0 0 21 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#speech-bubble-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stockist-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "stockist-small-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#stockist-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stockist.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "stockist-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#stockist-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stop.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "stop-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#stop-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\stores-stockists.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "stores-stockists-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#stores-stockists-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\subnav-toggle--indicator-closed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "subnav-toggle--indicator-closed-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#subnav-toggle--indicator-closed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\subnav-toggle--indicator-opened.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "subnav-toggle--indicator-opened-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#subnav-toggle--indicator-opened-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\success-tick-for-all-success.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "success-tick-for-all-success-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#success-tick-for-all-success-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\success.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "success-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#success-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\support.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "support-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#support-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\telephone-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "telephone-small-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#telephone-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\telephone.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "telephone-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#telephone-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\text-link-arrow-back.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "text-link-arrow-back-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#text-link-arrow-back-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\text-link-arrow-forward.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "text-link-arrow-forward-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#text-link-arrow-forward-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\text-link-arrow.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "text-link-arrow-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#text-link-arrow-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\tick-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "tick-small-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#tick-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\tick.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "tick-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#tick-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\tiktok-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "tiktok-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#tiktok-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\trash-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "trash-small-usage",
      viewBox: "0 0 14 14",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#trash-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\trash.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "trash-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#trash-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\twitter-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "twitter-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#twitter-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\ui-tick.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "ui-tick-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#ui-tick-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\user.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "user-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#user-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-diamond.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "usp-diamond-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#usp-diamond-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-education.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "usp-education-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#usp-education-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-free-delivery.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "usp-free-delivery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#usp-free-delivery-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\usp-truck.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "usp-truck-usage",
      viewBox: "0 0 28 24",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#usp-truck-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\view-password-off.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "view-password-off-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#view-password-off-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\view-password-on.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "view-password-on-usage",
      viewBox: "0 0 20 20",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#view-password-on-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\view-previous-orders.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "view-previous-orders-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#view-previous-orders-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\website-small.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "website-small-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#website-small-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\website.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "website-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#website-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\your-cart-is-empty.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "your-cart-is-empty-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#your-cart-is-empty-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\your-order-confirmed.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "your-order-confirmed-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#your-order-confirmed-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\youtube-social.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "youtube-social-usage",
      viewBox: "0 0 32 32",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#youtube-social-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\zoom-in.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "zoom-in-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#zoom-in-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\zoom-out.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "zoom-out-usage",
      viewBox: "0 0 72 72",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#zoom-out-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\svg-sprite-loader\\lib\\loader.js??ref--14-0!D:\\a\\1\\s\\client\\src\\site__evo\\sprites\\zoom.svg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
      id: "zoom-usage",
      viewBox: "0 0 28 28",
      url: __webpack_require__.p + "images/sprites__evo--25481a7f3c6f7ac71394be5578e7b2c5.svg#zoom-usage",
      toString: function () {
        return this.url;
      }
    }

/***/ }),

/***/ "D:\\a\\1\\s\\node_modules\\webpack\\buildin\\amd-options.js":
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),

/***/ "multi D:\\a\\1\\s/client/src/site__evo/index.js D:\\a\\1\\s/css/site__evo.css":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("D:\\a\\1\\s\\node_modules\\babel-loader\\lib\\index.js??ref--12-0!D:\\a\\1\\s\\node_modules\\eslint-loader\\index.js??ref--12-1!D:\\a\\1\\s\\client\\src\\site__evo\\index.js");
module.exports = __webpack_require__("D:\\a\\1\\s\\node_modules\\extract-text-webpack-plugin\\dist\\loader.js??ref--15-0!D:\\a\\1\\s\\node_modules\\css-loader\\index.js??ref--15-1!D:\\a\\1\\s\\node_modules\\postcss-loader\\lib\\index.js??ref--15-2!D:\\a\\1\\s\\css\\site__evo.css");


/***/ })

},["multi D:\\a\\1\\s/client/src/site__evo/index.js D:\\a\\1\\s/css/site__evo.css"]);


// WEBPACK FOOTER //
// scripts/site__evo--750700b3e7fc7d51d0c1.js